import React, { ChangeEvent, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../components/TextAreaComponents/TextAreaComponents.tsx";
import galleryIcon from "./../../../assets/icons/gallery.png";
import plusIcon from "./../../../assets/icons/plus.png";
import "./AddItem.css";
import { Delete, EditCalendar } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import StickyHeadTable from "../../components/SpecificationTable/Specification.tsx";
import Details from "./../../product/components/Details.tsx";
import Story from "./../../product/components/Story.tsx";
import Instructions from "./../../product/components/Instructions.tsx";
import Cancel from "./../../../assets/icons/close.png";
import AddSectionDialog from "./AddSectionDialog.tsx";
import AddSpecification from "./AddSpecifications/AddSpecification.tsx";
import KeywordDialog from "./KeywordDialog.tsx";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import ImportSpecification from "./ImportSpecification/ImportSpecification.tsx";
import TimingComponenet from "../../components/TimingComponenet/TimingComponenet.tsx";
import ArrowUpIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownIcon from "@mui/icons-material/ArrowDownward";
import Stack from "@mui/material/Stack";
import InfoIcon from "./../../../assets/images/info.png";

import { option } from "yargs";
import ChickenIcon from "./../../../assets/icons/turkey.png";
import ChickenLegIcon from "./../../../assets/icons/chicken-leg.png";
import Burger1Icon from "./../../../assets/icons/burger1.png";
import Burger2Icon from "./../../../assets/icons/burger.png";
import FullPizzaIcon from "./../../../assets/icons/pizza.png";
import pizzaIcon from "./../../../assets/icons/pizza (1).png";
import previewImg from "./../../../assets/icons/preview.png";
import itemImg from "./../../../assets/icons/Item.png";
import importImg from "./../../../assets/icons/import.png";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Chip from "@mui/material/Chip";

import SchedulerView from "./../components/SchedulerView/SchedulerView.tsx";
import CreateNewSchedule from "./SchedulerView/ScheduleItemDialog/CreateNewSchedule/CreateNewSchedule.tsx";
import SchedulerComponent from "./SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx";
import ImportItemView from "./ImportItemView/ImportItemView.tsx";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";

import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import axios from "axios";
import { getAPI } from "./../../../api/Common.js";
import { uploadOneFiles } from "./../../../fileUploader/SingleFileUploader.js";
import { ToastContainer, toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import { cleanLeadingZeros } from "@mui/x-date-pickers/internals/hooks/useField/useField.utils.js";
import preloader from "./../../../assets/images/LoadingSpin.gif";
import LoadingView from "../../components/LoadingView/LoadingView.js";

import FoodItemArchiveDialog from "../components/ArchiveDialog/FoodItemArchiveDialog.tsx";

import FoodItemCopyDialog from "../components/CopyDialog/FoodItemCopyDialog.tsx";

import FoodItemLinkDialog from "../components/FoodItemLinkDialog.tsx";
import EditRankDialog from "./EditRankDialog/EditRankDialog.tsx";
import Kitchens from "./Kitchens/Kitchens.tsx";
import EditItemSchedulerSelectionDialog from "./EditItemSchedulerSelectionDialog.tsx";
import EditDeliveryDialog from "./EditDeliveryDialog.tsx";
import EditItemKitchen from "./EditItemKitchen.tsx";
import AddMenuDialog from "./AddMenuDialog.tsx";

import SweetAlertModal from "../../../pages/components/SweetAlertModal/SweetAlertModal.js";

interface ImageUploadState {
  // selectedImage: string | null
  selectedImages: string[];
}

function EditItemDialog(props) {
  //validation states start
  const [Editdata, setEditData] = useState(props.editData);
  const [RestaurantErr, setRestaurantErr] = useState(false);
  const [MainsectionErr, setMainsectionErr] = useState(false);
  const [SectionErr, setSectionErr] = useState(false);
  const [SubSectionErr, setSubSectionErr] = useState(false);
  const [ItemNameErr, setItemNameErr] = useState(false);
  const [DescriptionErr, setDescriptionErr] = useState(false);
  const [ImageErr, setImageErr] = useState(false);
  const [KeywordErr, setKeywordErr] = useState(false);
  const [KeywordTagsErr, setKeywordTagsErr] = useState(false);
  const [PriceErr, setPriceErr] = useState(false);
  const [VatErr, setVatErr] = useState(false);
  const [AddonsErr, setAddonsErr] = useState(false);
  const [linkedFoodItems, setLinkedFoodItems] = useState([]);
  const [initlinkedFoodItems, setinitLinkedFoodItems] = useState([]);
  const [linkedFoodItems2, setLinkedFoodItems2] = useState([]);
  const [linkedFoodItemsAdded, setLinkedFoodItemsAdded] = useState([]);

  const [initrestaurantAdded, setinitRestaurantAdded] = useState([]);
  const [initMenuAdded, setinitMenuAdded] = useState([]);
  const [initSectionAdded, setinitSectionAdded] = useState([]);
  const [foodItemData, setFoodItemData] = useState([]);

  //validation  states end

  const [value, setValue] = React.useState("1");
  const [switchCheck, setswitchCheck] = useState(
    Editdata.foodItems.isSubSection
  );
  const [defaultvalue, setDefaultvalue] = useState({});
  // const { title } = props.title
  //Addsection dialog control start
  const [openAddKeyword, setOpenAddKeyword] = useState(false);

  const [openAddSection, setOpenAddSection] = useState(false);

  // const [openSchedule, setSchedule] = useState(false);
  const [dialogType, setDialogType] = useState("");

  const [loadingModal, SetloadingModal] = React.useState(false);

  console.log("Editdata", Editdata);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  const handleClickOpen = () => {
    setOpenAddSection(true);
    setDialogType("Add Section");
  };
  const handleClickOpenOk = () => {
    setOpenAddSection(true);
    setDialogType("Add Sub Section");
  };
  const handleClickKeyword = () => {
    setOpenAddKeyword(true);
  };
  const handleAddItem = (AddSectionData) => {
    setOpenAddSection(AddSectionData);
  };

  const handleKeywordDialog = (KeywordDialog) => {
    setOpenAddKeyword(KeywordDialog);
  };
  //AddSpecification modal open functionality
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCloseSpecifications = () => {
    setOpen(false);
  };
  //Addsection dialog controll end
  const [openImportSpecification, setopenImportSpecification] = useState(false);
  //image upload code start
  const handleopenImportSpecification = () => {
    setopenImportSpecification(true);
  };

  const handleCloseImportSpecification = () => {
    setOpen(false);
  };
  const [state, setState] = useState<ImageUploadState>({
    selectedImages: Editdata ? Editdata.imgaes : [],
  });
  const [initstate, setinitState] = useState<ImageUploadState>({
    selectedImages: Editdata ? Editdata.imgaes : [],
  });

  const [imageFile, setImageFile] = useState([]);
  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);

      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        setImageFile((prevItems) => [...prevItems, file]);

        //setImageFile((prevItems: File[]) => (prevItems ? [...prevItems, file] : [file]));

        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
    setImageErr(false);
  };
  const handleDeleteImage = (index: number) => {

    for (let i = 0; i < state.selectedImages?.length; i++) {
      if (
        typeof state.selectedImages[i] === "string" &&
        state.selectedImages[i].startsWith("https://")
      ) {
        const updatedImages = [...state.selectedImages];
        updatedImages.splice(index, 1);
        setState({ selectedImages: updatedImages });
      }
      else {
        const updateImageFile = [...imageFile];
        updateImageFile.splice(index, 1);
        setImageFile(updateImageFile);
      }
    }
  };

  //image upload code end

  const handleSwitchChange = () => {
    setswitchCheck(!switchCheck);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const handleClose = () => {
    //props.onHandleAddItem(false);
    setopenConfirmaitonModal(true);
  };
  const onHandleAddItem = () => { };
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [specificationRows, setSpecificationRows] = React.useState([]);
  const handleAddSpecification = (newSpecification) => {
    // Add the new specification to the existing rows data
    setSpecificationRows((prevRows) => [...prevRows, newSpecification]);
  };
  const apiAddress = process.env.REACT_APP_SECRET;
  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));

  const [restaurantDatas, setRestaurantDatas] = React.useState([]);

  const token = localStorage.getItem("gotasteadmintoken");

  const [userId, setUserId] = useState();
  const loadRestaurantName = () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) { }
    }
    console.log(decodedData.UserId);
    if (decodedData.UserId) {
      axios
        // .get(apiAddress + "/api/RestaurantUserMapper/getbyuserid/" + decodedData.UserId)
        .get(
          apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
        )
        .then((response) => {
          var list = [];
          response.data.map((dt, i) => {
            var obj = {
              id: dt.restaurantId,
              title: dt.restaurantName,
            };
            list.push(obj);
          });
          console.log(list);
          setRestaurantDatas(list);
          loadEditRestaurant(list);
        });
    }
  };

  const [addOnDatas, setAddons] = useState([]);
  const [DefaultAddons, setDefaultAddons] = useState([]);

  const loadDefaultAddons = (data) => {
    console.log(data)
    var list = [];
    var objList = [];
    Editdata.foodItemAddOnsMapperList.map((d, i) => {
      var obj = data.find((x) => x.id == d.addOnsId);
      var addonsObj = {
        Id: d?.id,
        FoodItemId: d?.foodItemId,
        AddOnsId: obj?.id,
        CreationId: "123",
        LinkedItemIds: d?.linkedItemIds,
        title: obj?.title,
        Rank: d.rank,
        isCountableLinked: d?.isCountableLinked,
        isMandatory: d?.isMandatory,
        isCountable: obj?.isCountable,
        isMustPick: d?.isMustPick
      };
      if (obj != undefined) {
        list.push(obj);
      }
      objList.push(addonsObj);
      console.log(list)
    });

    setisMustPick(objList[0]?.isMustPick ?? false)
    setDefaultAddons(list);
    setSelectedAddons(objList);
    setinitSelectedAddons(objList)
  };

  const loadAddons = async (restaurant) => {
    console.log("Hit")

    axios
      // .get(apiAddress + "/api/AddOns/GetAllAddOns")
      .post(
        apiAddress + "/api/AddOns/GetAddOnsMasterByRestaurantIdList",
        restaurant
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.isCountable ? dt.addOnName + " | Countable" : dt.addOnName,
            isCountable: dt.isCountable
          };
          list.push(obj);
        });
        // if(addOnDatas.length>0 && DefaultAddons.length == 0){
        // 
        // }
        loadDefaultAddons(list)
        setAddons(list);
      });
  };

  useEffect(() => {
    if (addOnDatas.length > 0) {
      loadDefaultAddons(addOnDatas);
    }
  }, [Editdata.foodItemAddOnsMapperList]);

  const [keywordDatas, setkeywordDatas] = React.useState([]);

  async function keyworddataByRestaurantId() {
    var list = [];
    var response = await axios.get(apiAddress + "/api/Keyword");
    list.push(response.data);
    return list;
  }

  const loadKeyword = async () => {
    var list = await keyworddataByRestaurantId();
    var KeywordList = [];
    console.log(list);
    list[0].map((d, i) => {
      var obj = { id: d.id, title: d.keywordName };
      KeywordList.push(obj);
    });
    console.log(KeywordList);
    if (KeywordList.length > 0 && Editkeyword.length == 0) {
      await loadMapperData(KeywordList);
    }

    setkeywordDatas(KeywordList);
  };
  const [Menudata, setMenuData] = useState([]);
  const [EditMenu, setEditMenu] = useState([]);
  const [allMenuData, setAllMenuData] = useState([]);

  const loadMenuData = async () => {
    var list = [];
    var Alllist = [];
    restaurantAdded.map(async (d, i) => {
      const response = await axios.get(apiAddress + "/api/Menu/" + d.id);
      console.log(d.id);
      response.data.map((dt, i) => {
        var obj = {
          id: dt.menuId,
          title: dt.menuName,
          img: dt.logoUrl,
          restaurantName: dt.restaurantName,
          restaurantId: d.id,
        };
        list.push(obj);
        console.log(list);
        dt.MenuRestaurantMapperLists = [];
        Alllist.push(dt);
        loadEditMenus(list);
      });
      // Alllist = response.data;
    });
    setAllMenuData(Alllist);
    console.log(list.length, typeof list);
    setMenuData(list);
    //loadSectionData();
  };

  const [keywordTagdata, setKeywordTag] = useState([]);

  const [DefaultKeywordTag, setDefaultKeywordTag] = useState([]);
  const loadDeafultKeywordtag = (data) => {
    console.log(data);
    var list = [];
    var objList = [];
    Editdata.foodItemKeywordTagMapperList.map((d, i) => {
      var obj = data.find((x) => x.id == d.keywordTagId);
      console.log(obj)
      var tagObj = {
        Id: d.id,
        FoodItemId: d.foodItemId,
        KeywordTagId: obj.id,
        CreationId: "123",
        LinkedItemIds: d.linkedItemIds,
        title: obj.title
      };
      list.push(obj);
      objList.push(tagObj);
    });
    setDefaultKeywordTag(list);
    setKeywordTagList(objList);
    setinitKeywordTagList(objList);
  };

  console.log(Editdata);
  const loadKeywordTags = async () => {

    await axios
      .get(apiAddress + "/api/Keyword/GetALlKeywordTag")
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = { id: dt.id, title: dt.keywordTagName };
          list.push(obj);
        });
        if (DefaultKeywordTag.length == 0) {
          loadDeafultKeywordtag(list);
        }
        setKeywordTag(list);
      });
  };

  const [KeywordVal, setKeywordVal] = useState([]);
  const KeywordaddValue = (props) => {
    // setAutoCompleteValue(props)
    // setKeywordVal(props);
  };
  const [restaurantAdded, setRestaurantAdded] = useState([]);
  const [Sectiondata, setSectiondata] = useState([]);
  //Section icon show start
  const [selectedValue, setSelectedValue] = useState([]);

  const restaurantAddedvalue = (newValue) => {
    console.log(newValue);
    const removedRestaurants = restaurantAdded.filter(
      (restaurant) => !newValue.some((newItem) => newItem.id === restaurant.id)
    );

    setRestaurantAdded(newValue);
    setRestaurantErr(false);

    // Filter out removed restaurants from the menu and section lists
    const updatedMenu = menuid.filter(
      (menu) =>
        !removedRestaurants.some(
          (restaurant) => menu.id === restaurant.linkedMenuId
        )
    );
    setMenuId(updatedMenu);

    const updatedSection = selectedValue.filter(
      (section) =>
        !removedRestaurants.some(
          (restaurant) => section.linkedRestaurantId === restaurant.id
        )
    );
    setSelectedValue(updatedSection);
  };

  const findRemovedElement = (fullArr, partialArr) => {
    const partialIds = new Set(partialArr.map((item) => item.id));
    return fullArr.find((item) => !partialIds.has(item.id));
  };

  const linkedFoodItemAddedvalue = (props) => {
    console.log(props);
    setLinkedFoodItemsAdded(props);
  };

  useEffect(() => {
    let modifiedList = [];
    modifiedList = [...linkedFoodItemsAdded];
    modifiedList.push({
      id: Editdata.foodItems.id,
      title:
        Editdata.foodItems.itemName +
        " | " +
        Editdata.foodItems.foodItemRestaurantName,
    });
    setLinkedFoodItems2(modifiedList);
  }, [linkedFoodItemsAdded]);

  const addScheduleValue = (props) => {
    // setAutoCompleteValue(props)
  };

  const textFieldValue = (props) => {
    setAutoCompleteValue(props);
    // setselectedItemValue(props);
  };

  const [netWeightVal, setnetWeightVal] = useState();
  const netWeightValue = (props) => {
    setnetWeightVal(props);
    // setselectedItemValue(props);
  };
  const [selectedItemValue, setselectedItemValue] = useState(
    Editdata.foodItems.itemName
  );
  const [initselectedItemValue, setinitselectedItemValue] = useState(
    Editdata.foodItems.itemName
  );

  const [initMinimumOrderSize, setinitMinimumOrderSize] = useState(
    Editdata.foodItems.minimumOrderSize
  );
  const [initMinimumIncrementSize, setinitMinimumIncrementSize] = useState(
    Editdata.foodItems.minimumIncrementSize
  );

  const nameValue = (props) => {
    setselectedItemValue(props);
    setItemNameErr(false);
  };

  const [descirptionVal, setdescirptionVal] = useState(
    Editdata.foodItems.description
  );
  const [initdescirptionVal, setinitdescirptionVal] = useState(
    Editdata.foodItems.description
  );

  const descirptionValue = (props) => {
    setdescirptionVal(props);
    setDescriptionErr(false);
  };


  const [minimumOrderSize, setminimumOrderSize] = useState(
    Editdata ? Editdata.foodItems.minimumOrderSize : ""
  );

  const [maximumOrderSize, setmaximumOrderSize] = useState(
    Editdata ? Editdata.foodItems.maximumOrderSize : ""
  );

  const [minimumIncreamentSize, setminimumIncreamentSize] = useState(
    Editdata ? Editdata.foodItems.minimumIncrementSize : ""
  );
  const AddMinimumOrderValue = (props) => {
    setminimumOrderSize(props);
    console.log(props)
  };
  const AddMinimumIncreamentValue = (props) => {
    setminimumIncreamentSize(props);
  };

  const AddMaximumOrderValue = (props) => {
    setmaximumOrderSize(props);
  };


  const [priceExclusive, setPriceExclusive] = useState(
    Editdata ? Editdata.foodItems.itemBasePrice : 0
  );
  const [initpriceExclusive, setinitPriceExclusive] = useState(
    Editdata ? Editdata.foodItems.itemBasePrice : 0
  );
  const setpriceExclusiveval = (props) => {
    setPriceExclusive(props);
    setPriceErr(false);
  };
  console.log(priceExclusive);
  const [vatAmount, setVatAmount] = useState(0);
  const [vatInAmount, setvatInAmount] = useState(
    Editdata ? Editdata.foodItems.specifyVATinPercentage : 0
  );
  const [priceInclusive, setpriceInclusive] = useState(0);
  const inAmountVATValue = (props) => {
    // var Vatprice = props * 100;
    // var total = Vatprice / priceExclusive;
    // setvatInAmount(total);
    // setVatAmount(props);
    // setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
  };

  const inPercentageVATValue = (props) => {
    // var Vatprice = props / 100;
    // var total = Vatprice * priceExclusive;
    // setVatAmount(total);
    // setvatInAmount(props);
    // setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
    // setVatErr(false);
  };


  const [radiovalue, setRadioValue] = React.useState(
    Editdata.foodItems.vatType
  );
  const [initradiovalue, setinitRadioValue] = React.useState(
    Editdata.foodItems.vatType
  );
  const [isactive, setIsactive] = React.useState(false);

  const [vatDatas, setvatDatas] = useState([]);
  const [vatAdded, setvatAdded] = useState(null);
  const [initvatAdded, setinitvatAdded] = useState(null);
  const [customVat, setCustomVat] = useState(
    Editdata ? Editdata.foodItems.specifyVATinPercentage : 0
  );
  const [initcustomVat, setinitCustomVat] = useState(
    Editdata ? Editdata.foodItems.specifyVATinPercentage : 0
  );
  const [isAutocompleteDisabled, setIsAutocompleteDisabled] = useState(false);
  const [isRadioDisabled, setIsRadioDisabled] = useState(false);

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setRadioValue(value);

    if (value === "Specify") {
      setvatAdded(null); // Clear selected VAT when switching to custom input
      setCustomVat("");  // Reset custom VAT field
    } else {
      setCustomVat("");  // Reset custom VAT when switching to Autocomplete
    }
  };

  const handleimportedDatas = () => {
    setopenImportSpecification(false);
  };
  const [quantity, setquantity] = React.useState(0);

  const [imageMap, setimageMap] = useState([]);

  const [menuid, setMenuId] = useState([]);
  const [EditSection, setEditSection] = useState([]);

  const addValue = async (props) => {
    console.log(props);
    var selectedList = [];
    props.map((obj) => {
      const object = Menudata.find((x) => x.id == obj.id);
      selectedList.push(object);
    });
    setMenuId(selectedList);
    setMainsectionErr(false);
    //await loadSectionData();

    const removedMenu = menuid.filter(
      (menu) => !props.some((newItem) => newItem.id === menu.id)
    );

    const updatedSection = selectedValue.filter(
      (section) => !removedMenu.some((menu) => section.linkedMenuId === menu.id)
    );
    setSelectedValue(updatedSection);
  };
  const [allSectiondata, setallSectiondata] = useState([]);

  const loadSectionData = async () => {
    let sections = [];
    let Allsections = [];
    menuid.map(async (d, i) => {
      const response = await axios.get(
        apiAddress + "/api/Section/getallsectionbasedonmenuid?id=" + d.id
      );
      response.data.map((dt, i) => {
        let sectionNew = {
          id: dt.id,
          title: dt.keywordName,
          img: dt.iconUrl,
          menuId: d.id,
          restaurantId: d.restaurantId,
          restaurantName: d.title,
        };
        sections.push(sectionNew);

        Allsections.push(dt);
        //loadEditSection(sections);
      });
      // Alllist = response.data;
    });
    setallSectiondata(Allsections);
    setSectiondata(sections);
  };
  const loadSection = (list) => {
    var obj = list;
    if (obj != undefined) {
      setMenuId(obj.id);

      axios
        .get(
          apiAddress + "/api/Section/getallsectionbasedonmenuid?id=" + obj.id
        )
        .then((response) => {
          console.log(response.data);
          var list = [];
          response.data.map((dt, i) => {
            var obj = { code: dt.id, icon: dt.iconUrl, label: dt.keywordName };

            if (dt.id == Editdata.foodItems.sectionId) {
              console.log("if called");
              var obj2 = {
                code: dt.id,
                icon: dt.iconUrl,
                label: dt.keywordName,
              };
              // setSelectedValue(obj2)
              loadSubSection(obj2);

              setEditSection(obj2);
            }

            list.push(obj);
          });
          setimageMap(list);
        });
    }
  };

  const loadSubSection = () => {
    axios
      .get(
        apiAddress +
        "/api/SubSection/getallsubsection"
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj =
          {
            id: dt.id,
            title: dt.keywordName,
            img: dt.iconUrl
          };
          list.push(obj);
        });
        setSubsectionImage(list);
      });
  };
  const [subSectionImage, setSubsectionImage] = useState([]);
  const handleAutocompleteChange = (event: ChangeEvent<{}>, value: any) => {
    setSelectedValue(value);
    setSectionErr(false);

  };

  const handleImportItem = (props) => {
    // let val = Menudata.find(x => x.title === props.section);
    var index = Menudata.findIndex((x) => x.title === props.section);

    setDefaultvalue(Menudata[index]);

    setOpenImport(false);

    // section
    var arr = [];
    arr.push(imageMap[1]);
    arr.push(imageMap[5]);
    setSelectedValue(arr);
    // sub section
    setswitchCheck(true);
    var arr2 = [];
    arr2.push(imageSectionMap[2]);
    arr2.push(imageSectionMap[4]);
    setSelectedSectionValue(arr2);

    // item
    setselectedItemValue("");
    setselectedItemValue(props.item);

    // description

    setdescirptionVal(
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unkown printer took a galley of type"
    );

    // keywords
    var arr3 = [];
    arr3.push(keywordDatas[2]);
    arr3.push(keywordDatas[4]);
    setKeywordVal(arr3);

    // price exclusive
    setPriceExclusive(1200);

    // vat
    setvatInAmount(10);
    var Vatprice = 10 * 100;
    var total = Vatprice / priceExclusive;
    setvatInAmount(total);
    setVatAmount(10);
    setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    // net weight
    setnetWeightVal(10);
  };

  //Section icon show end

  const imageSectionMap = [
    { codeSection: 1, icon: ChickenIcon, label: "Full chicken" },
    { codeSection: 2, icon: ChickenLegIcon, label: "Chicken" },
    { codeSection: 3, icon: Burger1Icon, label: "Burger 1" },
    { codeSection: 4, icon: Burger2Icon, label: "Burger 1" },
    { codeSection: 5, icon: FullPizzaIcon, label: "Pizza 1" },
    { codeSection: 6, icon: pizzaIcon, label: "Pizza 2" },
  ];

  const getFoodSectionImage = (codeSection) => {
    const foundSectionItem = imageSectionMap.find(
      (item) => item.codeSection === codeSection
    );
    if (foundSectionItem) {
      return foundSectionItem.icon;
    }
    return null;
  };
  const [selectedSectionValue, setSelectedSectionValue] = useState([]);
  const handleAutocompleteSectionChange = (
    event: ChangeEvent<{}>,
    value: any
  ) => {
    setSelectedSectionValue(value);

    setSubSectionErr(false);
  };

  //sub section icon show end

  // Stepper Start
  const steps = ["Add Item"];
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    if (!isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const [options, setOptions] = React.useState(props.datas);

  const handleKeyDown = (event) => {

    if (event.key === "Enter") {
      event.preventDefault(); // Prevent the default Enter key action

      const inputValue = event.target.value.trim();
      if (
        inputValue &&
        !keywordDatas.some((option) => option.title === inputValue)
      ) {
        // Add the new value to the array
        let KeywordRestaurantMapperList = [];
        restaurantAdded.map((dt, i) => {
          KeywordRestaurantMapperList.push(dt?.id)
        })

        var obj = {
          id: "string",
          keywordName: inputValue,
          restaurantId: RestauranttokenLocal.id,
          isActive: true,
          creatorId: "string",
          creationDate: "2023-08-21T06:38:08.240Z",
          modifierId: "string",
          modificationDate: "2023-08-21T06:38:08.240Z",
          restaurantIds: KeywordRestaurantMapperList
        }
        var url = apiAddress + "/api/Keyword"

        axios
          .post(url, obj)
          .then((response) => {
            var list = []
            var list2 = []
            var obj = {
              Id: "123",
              FoodItemId: "123",
              KeywordId: response.data.id,
              CreationId: "123",
            };
            var obj2 = {
              id: response.data.id,
              title: inputValue
            }
            list.push(obj)
            list2.push(obj2)
            //setkeywordObjlist(list)
            setkeywordObjlist([...keywordObjlist, obj])
            setEditKeyword([...Editkeyword, obj2])
            setkeywordDatas([...keywordDatas, { id: response.data.id, title: inputValue }]);
          });
      }

      // Clear the input field
      event.target.value = "";
    }
  };
  // Stepper End
  const [openImport, setOpenImport] = React.useState(false);

  //tooltip start
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  }));

  //tooltip end
  function createData(
    Rank: string,
    AddonName: string,
    IsToggle: string,
    buttonStyle: string,
    maxSelection: string,
    option: [],
    isCountableLinked: boolean,
    isMandatory: boolean,
    isCountable: boolean,
    isOptionMustPick: boolean

  ) {
    return {
      Rank,
      AddonName,
      IsToggle,
      buttonStyle,
      maxSelection,
      option,
      isCountableLinked,
      isMandatory,
      isCountable,
      isOptionMustPick,
    };
  }
  const [isMustPick, setisMustPick] = React.useState(false);

  const handleMustPick = () => {
    if (isMustPick == false) {
      setisMustPick(true);

      setRowsData(prevRows =>
        prevRows.map(row => ({
          ...row,
          isMandatory: false
        }))
      );
    }
    else if (isMustPick == true) {
      setisMustPick(false);
    }

  };

  const [isOptionMustPick, setisOptionMustPick] = React.useState(false);

  const handleOptionMustPick = (rowIndex) => {
    setRowsData((prevRows) =>
      prevRows.map((r, i) => {
        if (i === rowIndex) {
          const newIsOptionMustPick = !r.isOptionMustPick;

          return {
            ...r,
            isOptionMustPick: newIsOptionMustPick,
            option: newIsOptionMustPick
              ? r.option.map(opt => ({
                ...opt,
                addOnOptionsMaster: {
                  ...opt.addOnOptionsMaster,
                  isMandatory: false
                }
              }))
              : r.option
          };
        }
        return r;
      })
    );
  };

  const [maxVal, setMaxVal] = React.useState(0);

  const moveUp = (index) => {
    if (index === 0) return; // Can't move the first row up
    const newRows = [...rowsData];
    [newRows[index - 1], newRows[index]] = [newRows[index], newRows[index - 1]];
    // Update serial numbers
    newRows[index - 1].Rank -= 1;
    newRows[index].Rank += 1;
    setRowsData(newRows);
  };

  const moveDown = (index) => {

    if (index === rowsData.length - 1) return; // Can't move the last row down
    const newRows = [...rowsData];
    [newRows[index], newRows[index + 1]] = [newRows[index + 1], newRows[index]];

    //Update serial numbers
    newRows[index + 1].Rank += 1;
    newRows[index].Rank -= 1;
    setRowsData(newRows);
  }

  function Row(props: { row: ReturnType<typeof createData> }) {
    const { row, idx, onToggle, onMandetoryToggle } = props;
    const [open, setOpen] = React.useState(true);
    const [isMandatory, setIsMandatory] = React.useState(false);
    const handleMandatoryToggle = () => {
      setIsMandatory(!isMandatory);
    };

    const handleIsLinkedUpdate = (addonName, optionId, key, value) => {
      setRowsData((prevRows) =>
        prevRows.map((row) => {
          if (row.AddonName === addonName) {
            const updatedOptions = row.option.map((opt) =>
              opt.addOnOptionsMaster.id === optionId
                ? {
                  ...opt,
                  addOnOptionsMaster: {
                    ...opt.addOnOptionsMaster,
                    [key]: value,
                  },
                }
                : opt
            );

            const allLinked = updatedOptions.every(
              (opt) => opt.addOnOptionsMaster.isCountableLinked
            );
            const anyNotLinked = updatedOptions.some(
              (opt) => !opt.addOnOptionsMaster.isCountableLinked
            );

            return {
              ...row,
              option: updatedOptions,
              isCountableLinked: anyNotLinked ? false : allLinked,
            };
          }
          return row;
        })
      );
    };

    const handleIsMandatoryUpdate = (addonName, optionId, key, value) => {
      setRowsData((prevRows) =>
        prevRows.map((row) => {
          if (row.AddonName === addonName) {
            // Update the specific option
            const updatedOptions = row.option.map((opt) =>
              opt.addOnOptionsMaster.id === optionId
                ? {
                  ...opt,
                  addOnOptionsMaster: {
                    ...opt.addOnOptionsMaster,
                    [key]: value,
                  },
                }
                : opt
            );

            // Determine the new isMandatory for the addon
            const anyMandatory = updatedOptions.some(
              (opt) => opt.addOnOptionsMaster.isMandatory
            );
            const allNotMandatory = updatedOptions.every(
              (opt) => !opt.addOnOptionsMaster.isMandatory
            );

            return {
              ...row,
              option: updatedOptions,
              isMandatory: allNotMandatory ? false : anyMandatory, // If any option is true, set true, otherwise set false
            };
          }
          return row;
        })
      );
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell></TableCell>
          <TableCell align="center">
            <IconButton size="small" onClick={() => moveUp(idx)}>
              <ArrowUpIcon sx={{ width: "1.2rem", height: "1.2rem" }} />
            </IconButton>
            <span>{row?.Rank}</span>
            <IconButton size="small" onClick={() => moveDown(idx)}>
              <ArrowDownIcon sx={{ width: "1.2rem", height: "1.2rem" }} />
            </IconButton>
          </TableCell>
          <TableCell align="center" component="th" scope="row">
            {row?.isCountable ? `${row?.AddonName} | Countable` : row?.AddonName}
          </TableCell>
          <TableCell align="right">{row?.IsToggle}</TableCell>
          <TableCell align="right">{row?.buttonStyle}</TableCell>
          <TableCell align="right">{row?.maxSelection}</TableCell>
          <TableCell align="center">
            <Tooltip
              title={
                row?.isCountable
                  ? "For countable addons, all options are automatically linked when enabled"
                  : "Link all options with food item"
              }
            >
              <span>
                <Switch
                  checked={row?.isCountableLinked}
                  onChange={() => onToggle(idx)}
                />
              </span>
            </Tooltip>
          </TableCell>
          <TableCell align="center">
            <Switch
              checked={row?.isMandatory}
              onChange={() => onMandetoryToggle(idx)}
              disabled={isMustPick}
            />
          </TableCell>
        </TableRow>

        <TableRow>
          {row?.option.length > 0 ? (
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <Box sx={{ margin: 1 }}>
                  <Typography variant="h6" gutterBottom component="div">
                    Option
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell>Must Pick
                            <span>  </span>
                            <Switch
                              checked={row.isOptionMustPick}
                              onChange={() => handleOptionMustPick(idx)}
                              size="small"
                            />
                          </TableCell>
                          <TableCell>Option Name</TableCell>
                          <TableCell align="right">Base Price</TableCell>
                          <TableCell align="right">Vat</TableCell>
                          <TableCell align="right">Inclusive Price</TableCell>
                          <TableCell align="right">Link with fooditem</TableCell>
                          <TableCell align="right">Mandatory</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row?.option.map((opt) => (
                          <OptionRow
                            key={opt?.addOnOptionsMaster.id}
                            row={opt}
                            addonName={row.AddonName}
                            isCountableAddon={row.isCountable}
                            onIsLinkedUpdate={handleIsLinkedUpdate}
                            onIsMandatoryUpdate={handleIsMandatoryUpdate}
                            isOptionMustPickfromAddon={row.isOptionMustPick}
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Collapse>
            </TableCell>
          ) : (
            ""
          )}
        </TableRow>
      </React.Fragment>
    );
  }
  function OptionRow(props) {
    const { row, addonName, isCountableAddon, onIsLinkedUpdate, onIsMandatoryUpdate, isOptionMustPickfromAddon } = props;
    const [open, setOpen] = React.useState(false);

    const handleLinkedToggle = () => {
      if (isCountableAddon) return; // Prevent toggle if parent is countable
      onIsLinkedUpdate(
        addonName,
        row.addOnOptionsMaster.id,
        "isCountableLinked",
        !row.addOnOptionsMaster.isCountableLinked
      );
    };

    const handleMandatoryToggle = () => {
      onIsMandatoryUpdate(
        addonName,
        row.addOnOptionsMaster.id,
        "isMandatory",
        !row.addOnOptionsMaster.isMandatory
      );
    };

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell></TableCell>
          <TableCell component="th" scope="row">
            {row?.addOnOptionsMaster.optionName}
          </TableCell>
          <TableCell align="right">
            {row?.addOnOptionsMaster.basePrice}
          </TableCell>
          <TableCell align="right">
            {row?.addOnOptionsMaster.vaTinPercentage}
          </TableCell>
          <TableCell align="right">{row.inclusivePrice}</TableCell>
          <TableCell align="right">
            <Tooltip
              title={
                isCountableAddon
                  ? ""
                  : "Link this option with food item"
              }
            >
              <span>
                <Switch
                  checked={row.addOnOptionsMaster?.isCountableLinked}
                  onChange={handleLinkedToggle}
                  disabled={isCountableAddon}
                />
              </span>
            </Tooltip>
          </TableCell>
          <TableCell align="right">
            <Switch
              checked={row.addOnOptionsMaster?.isMandatory}
              onChange={handleMandatoryToggle}
              disabled={isOptionMustPickfromAddon}
            />
          </TableCell>
        </TableRow>
        {/* Render suboptions inside Collapse when expanded */}
        <TableRow>
                  {row.addOnSubOptionsMasterList.length > 0 ? (
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                      <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{ margin: 1 }}>
                          <Typography variant="h6" gutterBottom component="div">
                            Sub-Option
                          </Typography>
                          <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Sub Option Name</TableCell>
                                  <TableCell align="right">Price</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {row.addOnSubOptionsMasterList.map((subOptionRow) => (
                                  <SubOptionRow key={subOptionRow.subOptionName} row={subOptionRow} />
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                      </Collapse>
                    </TableCell>
                  ) : (
                    ""
                  )}
                </TableRow>
      </React.Fragment>
    );
  }
  function SubOptionRow(props) {
    const { row } = props;
    // const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell component="th" scope="row">
            {row.subOptionName}
          </TableCell>
          <TableCell align="right">
            {row.price}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }
  const [option, setOption] = React.useState([
    {
      optionName: "Tomato Sauce",
      Baseprice: 10,
      vat: 1,
      inclusivePrice: 11,
      suboption: [
        {
          suboptionName: "Hot Sauce",
          subBaseprice: 10,
          subvat: 1,
          subinclusivePrice: 11,
        },
        {
          suboptionName: "mild Sauce",
          subBaseprice: 10,
          subvat: 1,
          subinclusivePrice: 11,
        },
        {
          suboptionName: "Extreme Sauce",
          subBaseprice: 10,
          subvat: 1,
          subinclusivePrice: 11,
        },
      ],
    },
    {
      optionName: "Tomato Sauce",
      Baseprice: 10,
      vat: 1,
      inclusivePrice: 11,
      suboption: [],
    },
  ]);

  const [rowsData, setRowsData] = useState([]);
  const [tempRowsData, setTempRowsData] = useState([]);

  const [selectedAddons, setSelectedAddons] = useState([]);
  const [initselectedAddons, setinitSelectedAddons] = useState([]);

  const addonvalue = (props) => {
    var list = [];
    var obj2 = {};

    props.map((dt, i) => {
      // Extract original addon name if it contains "| Countable"
      const originalTitle = dt.title?.replace(" | Countable", "");

      const object = addOnDatas?.find((x) => x.title.replace(" | Countable", "") === originalTitle);
      const linkedobject = selectedAddons?.find((x) => x.title.replace(" | Countable", "") === originalTitle);
      let newRank = i + 1;

      var obj = {
        Id: linkedobject?.Id ?? "123",
        title: object?.title,
        FoodItemId: linkedobject?.FoodItemId ?? '123',
        AddOnsId: object?.id,
        CreationId: "123",
        LinkedItemIds: linkedobject?.LinkedItemIds ?? [],
        Rank: newRank,
        isCountableLinked: linkedobject?.isCountableLinked ?? false,
        isMandatory: linkedobject?.isMandatory ?? false,
        isCountable: object?.isCountable ?? false,
      };

      list.push(obj);
    });

    setSelectedAddons(list);
    setAddonsErr(false);
  };

  useEffect(() => {
    console.log("rowsData", rowsData);
  }, [rowsData])

  //getting details table data start
  const [details, setDetails] = useState([]);
  const getDetailsdata = (data) => {
    var list = [];
    data.map((dt, i) => {
      var obj = {
        id: dt.id,
        FoodItemId: "123",
        Details: dt.details,
        Description: dt.description,
        RankOrder: dt.rankOrder,
        CreationId: "123",
      };
      list.push(obj);
    });
    setDetails(list);
  };
  //getting details table data end

  //getting instruction table data start
  const [instruction, setInstruction] = useState([]);
  const getInstructiondata = (data) => {
    var list = [];
    data.map((dt, i) => {
      var obj = {
        id: "123",
        FoodItemId: "123",
        Name: dt.name,
        Description: dt.description,
        RankOrder: dt.rankOrder,
        CreationId: "123",
      };
      list.push(obj);
    });
    setInstruction(list);
  };

  //getting instruction table data end

  //getting story table data start

  const [story, setStory] = useState();
  const [storyObj, setStoryObj] = useState({
    id: "123",
    FoodItemId: "123",
    Story: Editdata.foodItemStory?.story ?? "",
    CreationId: "123",
  });
  const getStorydata = (data) => {
    var obj = { id: "123", FoodItemId: "123", Story: data, CreationId: "123" };
    setStory(obj);
  };
  //getting story table data end
  const [imageurl, setImageUrl] = useState([]);
  const fileUpload = async () => {
    var Url = [];
    if (imageFile?.length == 0) {
      setImageErr(true);
    }
    for (let i = 0; i < imageFile?.length; i++) {
      if (
        typeof imageFile[i] === "string" &&
        imageFile[i].startsWith("https://")
      ) {
        var obj = {
          Id: "123",
          FoodItemId: "123",
          ItemImagePath: imageFile[i],
          CreationId: "123",
          totalNumbersOfImage: '5',
          cropImageTypeId: '4314f388-816d-4ce0-b618-b7585b7a709e'
        };
        Url.push(obj);
      } else {
        var res = await uploadOneFiles(imageFile[i]);
        var obj = {
          Id: "123",
          FoodItemId: "123",
          ItemImagePath: res[0],
          CreationId: "123",
          totalNumbersOfImage: '5',
          cropImageTypeId: '4314f388-816d-4ce0-b618-b7585b7a709e'
        };
        Url.push(obj);
      }
    }
    // setImageUrl(Url)
    FoodItemInsertView.FoodItemImageMapperList = Url;
  };
  const [restaurantList, setRestaurantList] = useState([]);
  const restaurantMapper = () => {
    SetloadingModal(true);
    var list = [];
    if (restaurantAdded.length == 0) {
      setRestaurantErr(true);
    }
    restaurantAdded.map((item, i) => {
      var obj = {
        Id: "123",
        FoodItemId: "123",
        RestaurantId: item.id,
        CreationId: "123",
      };
      list.push(obj);
    });
    // setRestaurantList(list)
    FoodItemInsertView.FoodItemRestaurantMapperList = list;
  };

  const [FoodItemInsertView, setFoodItemInsertView] = useState({
    FoodItems: {},
  });

  const [Schedule, setSchedule] = React.useState([]);
  const getSchedule = (props) => {
    setSchedule(props);
    // Schedule.push(props)
  };
  //keyword start
  const [Editkeyword, setEditKeyword] = useState([]);
  const [keyword, setKeyword] = useState([]);
  const loadMapperData = (data) => {
    var list = [];
    var objList = [];
    if (data) {
      Editdata.foodItemKeywordMapperList.map((dt, i) => {
        var keyData = data.find((x) => x.id == dt.keywordId);

        if (keyData != undefined) {
          var obj = {
            Id: dt.id,
            title: keyData.title,
            FoodItemId: dt.foodItemId,
            KeywordId: keyData.id,
            CreationId: "123",
            LinkedItemIds: dt.linkedItemIds
          };
          objList.push(obj);
          list.push(keyData);
        }
      });
      setEditKeyword(list);
      setkeywordObjlist(objList);
      setinitkeywordObjlist(objList)
    }
  };

  const [selectedSubSectionValue, setSelectedSubSectionValue] = useState([]);
  const [initselectedSubSectionValue, setinitselectedSubSectionValue] = useState([]);

  const [keywordObjlist, setkeywordObjlist] = useState([]);
  const [initkeywordObjlist, setinitkeywordObjlist] = useState([]);

  const [keywordMsg, setkeywordMsg] = useState('');
  const [keywordMsgErr, setkeywordMsgErr] = useState(false);
  const [AddonsMsg, setAddonsMsg] = useState('');
  const [AddonsMsgErr, setAddonsMsgErr] = useState(false);
  const [keywordTagMsg, setkeywordTagMsg] = useState('');
  const [keywordTagMsgErr, setkeywordTagMsgErr] = useState(false);
  const [subFiltersMsgErr, setsubFiltersMsgErr] = useState(false);

  const [keywordCheck, setkeywordCheck] = useState(false);
  const [keywordTagCheck, setkeywordTagCheck] = useState(false);
  const [SubfiltersBruteCheck, setSubfiltersBruteCheck] = useState(false);
  const [ImageBruteCheck, setImageBruteCheck] = useState(false);
  const [AddonsBruteCheck, setAddonsBruteCheck] = useState(false);

  const [IsdeliverableCheck, setIsdeliverableCheck] = useState(Editdata.foodItems.isDelivery);
  const [initIsdeliverableCheck, setinitIsdeliverableCheck] = useState(Editdata.foodItems.isDelivery);

  const handleKeywordCheck = () => {
    if (keywordCheck == true) {
      setkeywordCheck(false);
    } else {
      setkeywordCheck(true);
    }
  };

  const handleKeywordTagCheck = () => {
    if (keywordTagCheck == true) {
      setkeywordTagCheck(false);
    } else {
      setkeywordTagCheck(true);
    }
  };

  const handleSubfiltersCheck = () => {
    if (SubfiltersBruteCheck == true) {
      setSubfiltersBruteCheck(false);
    } else {
      setSubfiltersBruteCheck(true);
    }
  };

  const handleImageBruteCheck = () => {
    if (ImageBruteCheck == true) {
      setImageBruteCheck(false);
    } else {
      setImageBruteCheck(true);
    }
  };

  const handleAddonsCheck = () => {
    if (AddonsBruteCheck == true) {
      setAddonsBruteCheck(false);
    } else {
      setAddonsBruteCheck(true);
    }
  };

  const handleDeliverableCheck = () => {
    if (IsdeliverableCheck == true) {
      setIsdeliverableCheck(false);
    } else {
      setIsdeliverableCheck(true);
    }
  };

  const [CancelledKeyword, setCancelledKeyword] = useState([]);

  useEffect(() => {
    const keywordCancelled = keywordNotMatched(initkeywordObjlist, keywordObjlist);
    var keywordCancelledwithLinkedItem = keywordCancelled.filter(item => item.LinkedItemIds.length > 0);

    if (keywordCancelled.length > 0) {

      keywordCancelled.forEach((row) => {
        if (row.LinkedItemIds.length > 0) {
          setkeywordMsgErr(true);
          setCancelledKeyword(keywordCancelledwithLinkedItem);
        }
      });
    }
    else {
      setkeywordMsgErr(false);
      setCancelledKeyword([])
    }
  }, [keywordObjlist]);

  const handleKeywordChange = (event, newvalue) => {
    var list = [];
    var list2 = [];
    newvalue.map((dt, i) => {
      const object = keywordDatas?.find((x) => x.title == dt);
      const linkedobject = initkeywordObjlist?.find((x) => x.title == dt);

      var obj = {
        Id: linkedobject?.Id ?? "123",
        title: object?.title,
        FoodItemId: linkedobject?.FoodItemId ?? '123',
        KeywordId: object?.id,
        CreationId: "123",
        LinkedItemIds: linkedobject?.LinkedItemIds ?? []
      }
      list.push(obj);

      console.log(list)

      var obj2 = {
        id: object?.id,
        title: dt
      }
      list2.push(obj2);
    });

    setEditKeyword(list2)
    setkeywordObjlist(list);
    setKeywordErr(false);
  };

  function keywordNotMatched(array1, array2) {

    const notMatched = [];

    for (let i = 0; i < array1.length; i++) {
      const element = array1[i];

      if (array2.find((x) => x.KeywordId == element.KeywordId) == undefined) {
        notMatched.push(element);
      }
    }
    return notMatched;
  }

  function KeywordModify() {
    var keywordcanclled = keywordNotMatched(initkeywordObjlist, keywordObjlist);
    var keywordadded = keywordNotMatched(keywordObjlist, initkeywordObjlist);

    let list = []
    let objList = []

    list = [...keywordcanclled, ...keywordadded]
    if (list.length > 0) {
      list.map((d, i) => {
        if (d?.Id != "123") {
          var obj = {
            Id: d?.Id,
            title: d?.title,
            FoodItemId: d?.FoodItemId ?? '123',
            KeywordId: d?.KeywordId,
            CreationId: "123",
            LinkedItemIds: d?.LinkedItemIds ?? [],
            Status: "Delete"
          }
          objList.push(obj)
        }
        else {
          var obj = {
            Id: d?.Id,
            title: d?.title,
            FoodItemId: d?.FoodItemId ?? '123',
            KeywordId: d?.KeywordId,
            CreationId: "123",
            LinkedItemIds: d?.LinkedItemIds ?? [],
            Status: "Add"
          }
          objList.push(obj)
        }
      })
      //setkeywordObjlist(objList)
    }
    else if (list.length === 0) {
      objList = keywordObjlist;
    }
    return objList;
  }

  //keyword end

  //keywordTag start
  const [keywordTagList, setKeywordTagList] = useState([]);
  const [initkeywordTagList, setinitKeywordTagList] = useState([]);

  const [CancelledKeywordTag, setCancelledKeywordTag] = useState([]);

  const addkeywordtag = (props) => {
    var list = [];
    var obj2 = {}
    props.map((dt, i) => {
      const object = keywordTagdata?.find((x) => x.title == dt.title);
      const linkedobject = initkeywordTagList?.find((x) => x.title == dt.title);
      var obj = {
        Id: linkedobject?.Id ?? "123",
        title: object?.title,
        FoodItemId: linkedobject?.FoodItemId ?? '123',
        KeywordTagId: object?.id,
        CreationId: "123",
        LinkedItemIds: linkedobject?.LinkedItemIds ?? []
      }
      list.push(obj);
    });
    setKeywordTagList(list);
    setKeywordTagsErr(false);
  };

  function keywordTagNotMatched(array1, array2) {
    const notMatched = [];

    for (let i = 0; i < array1.length; i++) {
      const element = array1[i];

      if (array2.find((x) => x.KeywordTagId == element.KeywordTagId) == undefined) {
        notMatched.push(element);
      }
    }
    return notMatched;
  }

  function KeywordTagModify() {

    var keywordTagcanclled = keywordTagNotMatched(initkeywordTagList, keywordTagList);
    var keywordTagadded = keywordTagNotMatched(keywordTagList, initkeywordTagList);
    let list = []
    let objList = []

    list = [...keywordTagcanclled, ...keywordTagadded]
    if (list.length > 0) {
      list.map((d, i) => {
        if (d?.Id != "123") {
          var obj = {
            Id: d?.Id,
            title: d?.title,
            FoodItemId: d?.FoodItemId ?? '123',
            KeywordTagId: d?.KeywordTagId,
            CreationId: "123",
            LinkedItemIds: d?.LinkedItemIds ?? [],
            Status: "Delete"
          }
          objList.push(obj)
        }
        else {
          var obj = {
            Id: d?.Id,
            title: d?.title,
            FoodItemId: d?.FoodItemId ?? '123',
            KeywordTagId: d?.KeywordTagId,
            CreationId: "123",
            LinkedItemIds: d?.LinkedItemIds ?? [],
            Status: "Add"
          }
          objList.push(obj)
        }
      })

    }
    else if (list.length === 0) {
      objList = keywordTagList;
    }
    return objList;
  }

  useEffect(() => {
    const keywordTagCancelled = keywordTagNotMatched(initkeywordTagList, keywordTagList);

    var keywordTagCancelledwithLinkedItem = keywordTagCancelled.filter(item => item.LinkedItemIds.length > 0);

    if (keywordTagCancelled.length > 0) {

      keywordTagCancelled.forEach((row) => {
        if (row.LinkedItemIds.length > 0) {
          setkeywordTagMsgErr(true);
          setCancelledKeywordTag(keywordTagCancelledwithLinkedItem);
        }
      });
    }
    else {
      setkeywordTagMsgErr(false);
      setCancelledKeywordTag([])
    }
  }, [keywordTagList]);

  //keywordtag end

  //Subfilters Start

  function SubfilterNotMatched(array1, array2) {
    const notMatched = [];

    for (let i = 0; i < array1.length; i++) {
      const element = array1[i];

      if (array2.find((x) => x.subfilterId == element.subfilterId) == undefined) {
        notMatched.push(element);
      }
    }
    return notMatched;
  }

  const [CancelledSubFilters, setCancelledSubFilters] = useState([]);

  function SubfiltersModify() {
    var subfiltercanclled = SubfilterNotMatched(initselectedSubSectionValue, selectedSubSectionValue);
    var subfilteradded = SubfilterNotMatched(selectedSubSectionValue, initselectedSubSectionValue);
    let list = []
    let objList = []

    list = [...subfiltercanclled, ...subfilteradded]
    if (list.length > 0) {
      list.map((d, i) => {
        if (d?.id != "123") {
          var obj = {
            id: d?.id,
            title: d?.title,
            foodItemId: d?.foodItemId ?? '123',
            subfilterId: d?.subfilterId,
            creationId: "123",
            linkedItemIds: d?.linkedItemIds ?? [],
            Status: "Delete"
          }
          objList.push(obj)
        }
        else {
          var obj = {
            id: d?.id,
            title: d?.title,
            foodItemId: d?.foodItemId ?? '123',
            subfilterId: d?.subfilterId,
            creationId: "123",
            linkedItemIds: d?.linkedItemIds ?? [],
            Status: "Add"
          }
          objList.push(obj)
        }
      })
      //setkeywordObjlist(objList)
    }
    else if (list.length === 0) {
      objList = selectedSubSectionValue;
    }

    return objList;
  }

  useEffect(() => {

    var subfiltercanclled = SubfilterNotMatched(initselectedSubSectionValue, selectedSubSectionValue);

    var SubFilterCancelledwithLinkedItem = subfiltercanclled.filter(item => item.linkedItemIds.length > 0);

    if (subfiltercanclled.length > 0) {

      subfiltercanclled.forEach((row) => {
        if (row.linkedItemIds.length > 0) {
          setsubFiltersMsgErr(true);
          setCancelledSubFilters(SubFilterCancelledwithLinkedItem);
        }
      });
    }
    else {
      setsubFiltersMsgErr(false);
      setCancelledSubFilters([])
    }
  }, [selectedSubSectionValue]);



  //Subfilters End

  //ImageModify start

  function ImageNotMatched(array1, array2) {
    const notMatched = [];

    for (let i = 0; i < array1.length; i++) {
      const element = array1[i];

      if (array2.find((x) => x == element) == undefined) {
        notMatched.push(element);
      }
    }
    return notMatched;
  }
  const ImageModify = () => {
    var Imagecanclled = ImageNotMatched(initstate.selectedImages, state.selectedImages);
    var ImageAdded = ImageNotMatched(state.selectedImages, initstate.selectedImages);

  }

  const ImagefileUpload = async () => {
    var Url = [];
    var deleteList = [];
    var addlist = [];
    var Imagecanclled = ImageNotMatched(initstate.selectedImages, state.selectedImages);
    var ImageAdded = ImageNotMatched(state.selectedImages, initstate.selectedImages);

    if (imageFile?.length == 0) {
      setImageErr(true);
    }

    if (Imagecanclled?.length > 0) {
      for (let i = 0; i < Imagecanclled?.length; i++) {
        var obj = {
          Id: "123",
          FoodItemId: "123",
          ItemImagePath: Imagecanclled[i],
          CreationId: "123",
          totalNumbersOfImage: '5',
          cropImageTypeId: '4314f388-816d-4ce0-b618-b7585b7a709e',
          Status: "Delete"
        };
        deleteList.push(obj);
      }
    }

    if (imageFile?.length > 0) {
      for (let i = 0; i < imageFile?.length; i++) {
        var res = await uploadOneFiles(imageFile[i]);
        var obj = {
          Id: "123",
          FoodItemId: "123",
          ItemImagePath: res[0],
          CreationId: "123",
          totalNumbersOfImage: '5',
          cropImageTypeId: '4314f388-816d-4ce0-b618-b7585b7a709e',
          Status: "Add"
        };
        addlist.push(obj);
      }
    }
    else {

    }
    Url = [...deleteList, ...addlist]
    console.log(Url)
    FoodItemInsertView.FoodItemImageMapperList = Url;
  };

  //ImageModify end

  //AddonsModify start

  function AddonsNotMatched(array1, array2) {
    const notMatched = [];

    for (let i = 0; i < array1.length; i++) {
      const element = array1[i];

      if (array2.find((x) => x.AddOnsId == element.AddOnsId) == undefined) {
        notMatched.push(element);
      }
    }
    return notMatched;
  }

  function AddonsModify() {
    const getBaseName = (name) => name?.replace(" | Countable", "");

    var addonscanclled = AddonsNotMatched(initselectedAddons, selectedAddons);
    var addonsadded = AddonsNotMatched(selectedAddons, initselectedAddons);
    let list = []
    let objList = []

    list = [...addonscanclled, ...addonsadded]
    if (list.length > 0) {
      list.map((d, i) => {
        if (d?.Id != "123") {
          const rank = rowsData.find((x) => getBaseName(x.AddonName) === getBaseName(d.title));
          var obj = {
            Id: d?.Id,
            title: d?.title,
            FoodItemId: d?.FoodItemId ?? '123',
            AddOnsId: d?.AddOnsId,
            CreationId: "123",
            LinkedItemIds: d?.LinkedItemIds ?? [],
            Status: "Delete",
            Rank: rank?.Rank || d?.Rank,
            isCountableLinked: rank?.isCountableLinked,
            isMandatory: rank?.isMandatory,
            isMustPick: isMustPick,
          }
          objList.push(obj)
        }
        else {
          const rank = rowsData.find((x) => getBaseName(x.AddonName) === getBaseName(d.title));
          var obj = {
            Id: d?.Id,
            title: d?.title,
            FoodItemId: d?.FoodItemId ?? '123',
            AddOnsId: d?.AddOnsId,
            CreationId: "123",
            LinkedItemIds: d?.LinkedItemIds ?? [],
            Status: "Add",
            Rank: rank?.Rank,
            isCountableLinked: rank?.isCountableLinked,
            isMandatory: rank?.isMandatory,
            isMustPick: isMustPick,
          }
          objList.push(obj)
        }
      })
      selectedAddons.map((d, i) => {
        const rank = rowsData.find((x) => getBaseName(x.AddonName) === getBaseName(d.title));
        var obj = {
          Id: d?.Id,
          title: d?.title,
          FoodItemId: d?.FoodItemId ?? '123',
          AddOnsId: d?.AddOnsId,
          CreationId: "123",
          LinkedItemIds: d?.LinkedItemIds ?? [],
          Status: "UpdateRank",
          Rank: rank?.Rank,
          isCountableLinked: rank?.isCountableLinked,
          isMandatory: rank?.isMandatory,
          isMustPick: isMustPick,
        };
        objList.push(obj);
      });
    }
    else if (list.length === 0) {
      var addonsobj = [];
      selectedAddons.map((d, i) => {
        const rank = rowsData.find((x) => getBaseName(x.AddonName) === getBaseName(d.title));
        var obj = {
          Id: d?.Id,
          title: d?.title,
          FoodItemId: d?.FoodItemId ?? '123',
          AddOnsId: d?.AddOnsId,
          CreationId: "123",
          LinkedItemIds: d?.LinkedItemIds ?? [],
          Status: "UpdateRank",
          Rank: rank?.Rank,
          isCountableLinked: rank?.isCountableLinked,
          isMandatory: rank?.isMandatory,
          isMustPick: isMustPick,
        };
        addonsobj.push(obj);
      });
      objList = addonsobj;
    }
    return objList;
  }

  const [CancelledAddons, setCancelledAddons] = useState([]);

  useEffect(() => {
    const AddonsCancelled = AddonsNotMatched(initselectedAddons, selectedAddons);
    var AddonsCancelledwithLinkedItem = AddonsCancelled.filter(item => item.LinkedItemIds.length > 0);

    if (AddonsCancelled.length > 0) {

      AddonsCancelled.forEach((row) => {
        if (row.LinkedItemIds.length > 0) {
          setAddonsMsgErr(true);
          setCancelledAddons(AddonsCancelledwithLinkedItem);
        }
      });
    }
    else {
      setAddonsMsgErr(false);
      setAddonsMsg('');
    }
  }, [selectedAddons]);

  useEffect(() => {
    loadAddonOptionListSuboptionList(selectedAddons)
  }, [selectedAddons]);

  const loadAddonOptionListSuboptionList = async (addonId) => {
    var dataList = [];
    var data;
    await Promise.all(
      addonId.map(async (d, i) => {
        try {
          if (d?.AddOnsId != undefined) {
            const response = await axios.get(
              apiAddress +
              "/api/AddOns/GetAddOnsOptionSuboptionByAddonId?addonId=" +
              d?.AddOnsId + "&fooditemId=" + props.editData.foodItems.id
            );
            data = createData(
              d.Rank,
              response.data.addOnsMaster.addOnName,
              response.data.addOnsMaster.isCollapsibleOption ? "true" : "N/A",
              response.data.addOnsMaster.optionButtonId == 3
                ? "Radio button"
                : response.data.addOnsMaster.optionButtonId == 4
                  ? "Check Box"
                  : response.data.addOnsMaster.optionButtonId == 5
                    ? "Button"
                    : response.data.addOnsMaster.optionButtonId == 6
                      ? "TextBox"
                      : "N/A",
              response.data.addOnsMaster.maxSelection
                ? response.data.addOnsMaster.maxSelection
                : "N/A",
              response.data.addOnOptionFormViews,
              d.isCountableLinked,
              d.isMandatory ?? true,
              response.data.addOnsMaster.isCountable,
              response.data.addOnOptionFormViews[0]?.addOnOptionsMaster?.isOptionMustPick ?? false
            );
          }
          dataList.push(data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      })
    );
    dataList.sort((a, b) => a.Rank - b.Rank);

    setRowsData(dataList);
  };

  const linktoggle = (index) => {
    setRowsData((prevRows) =>
      prevRows.map((row, idx) => {
        if (idx === index) {
          const newIsCountableLinked = !row.isCountableLinked;

          // For countable addons, all options must be linked when toggle is enabled
          const updatedOptions = row.option.map((opt) => ({
            ...opt,
            addOnOptionsMaster: {
              ...opt.addOnOptionsMaster,
              isCountableLinked: newIsCountableLinked,
            },
          }));

          return {
            ...row,
            isCountableLinked: newIsCountableLinked,
            option: updatedOptions,
          };
        }
        return row;
      })
    );
  };

  const mandatorytoggle = (index) => {
    setRowsData((prevRows) =>
      prevRows.map((row, idx) =>
        idx === index ? { ...row, isMandatory: !row.isMandatory } : row
      )
    );

    // setSelectedAddons((prevRows) =>
    //   prevRows.map((row, idx) =>
    //     idx === index ? { ...row, isMandatory: !row.isMandatory } : row
    //   )
    // );
  };

  const onSave = async () => {
    if (!!menuid == false) {
      setMainsectionErr(true);
      valid = false;
    }
    if (!!selectedValue.code == false) {
      setSectionErr(true);
      valid = false;
    }
    if (switchCheck && !!selectedSectionValue.code == false) {
      valid = false;
      setSubSectionErr(true);
    }
    if (!!selectedItemValue == false) {
      setItemNameErr(true);
      valid = false;
    }
    if (!!descirptionVal == false) {
      setDescriptionErr(true);
      valid = false;
    }
    if (keywordObjlist.length == 0) {
      setKeywordErr(true);
      valid = false;
    }
    if (keywordTagList.length == 0) {
      setKeywordTagsErr(true);
      valid = false;
    }
    if (!!priceExclusive == false) {
      setPriceErr(true);
      valid = false;
    }
    if (selectedAddons.length == 0) {
      setAddonsErr(true);
      valid = false;
    }
    //FoodItems start
    FoodItemInsertView.FoodItems.Id = "123";
    FoodItemInsertView.FoodItems.ItemName = selectedItemValue;
    FoodItemInsertView.FoodItems.Description = descirptionVal;
    //FoodItemInsertView.FoodItems.MainSectionId = menuid;
    //FoodItemInsertView.FoodItems.SectionId = selectedValue.code
    FoodItemInsertView.FoodItems.IsSubSection = switchCheck;
    FoodItemInsertView.FoodItems.SubSectionId = selectedSectionValue.code
      ? selectedSectionValue.code
      : "s";
    FoodItemInsertView.FoodItems.ItemBasePrice = priceExclusive;
    FoodItemInsertView.FoodItems.VATType = radiovalue;
    FoodItemInsertView.FoodItems.IsAnyAddOns = false;
    FoodItemInsertView.FoodItems.CreationId = "123";
    FoodItemInsertView.FoodItems.MinimumOrderSize = minimumOrderSize;
    FoodItemInsertView.FoodItems.MinimumIncrementSize = minimumIncreamentSize;
    //FoodItems end

    FoodItemInsertView.FoodItemDetailList = details; //details object
    FoodItemInsertView.FoodItemInstructionList = instruction; //instruction object
    FoodItemInsertView.FoodItemStory = story ? story : storyObj; //story object

    //restaurantMapperlist start

    await restaurantMapper();
    await fileUpload();
    var scheduleList = [];

    Schedule.map((dt, i) => {
      console.log(dt);
      dt.schedule.map((d, i) => {
        var obj = {
          Id: "123",
          FoodItemId: "123",
          SchedulerId: d.id,
          Quantity: dt.quantity,
          CreationId: "123",
        };
        scheduleList.push(obj);
      });
    });

    var addonsobj = [];
    selectedAddons.map((dt, i) => {
      var obj = {
        Id: "123",
        FoodItemId: "123",
        AddOnsId: dt,
        CreationId: "123",
      };
      addonsobj.push(obj);
    });

    FoodItemInsertView.FoodItemKeywordMapperList = keywordObjlist;
    FoodItemInsertView.FoodItemKeywordTagMapperList = keywordTagList;
    FoodItemInsertView.FoodItemAddOnsMapperList = addonsobj;
    FoodItemInsertView.FoodItemSchedulerMapperList =
      scheduleList.length > 0
        ? scheduleList
        : Editdata.foodItemSchedulerMapperList;

    //restaurantMapper list end

    //Additem validation start
    if (
      FoodItemInsertView.FoodItems.RestaurantId == "" ||
      FoodItemInsertView.FoodItems.MainSectionId == "" ||
      FoodItemInsertView.FoodItems.SectionId == "" ||
      FoodItemInsertView.FoodItems.ItemName == "" ||
      FoodItemInsertView.FoodItems.Description == "" ||
      FoodItemInsertView.FoodItems.ItemBasePrice == "" ||
      FoodItemInsertView.FoodItems.ItemImagePath == "" ||
      FoodItemInsertView.FoodItems.VATType == "" ||
      FoodItemInsertView.FoodItems.IsSubSection == undefined
    ) {
      valid = false;
      toast.error("one or more field is empty on Add Item", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    // if(story==undefined){
    //   valid=false
    //   toast.error("Story is empty", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",

    // })
    // }

    if (instruction.length == 0) {
      valid = false;
      toast.error("Instruction is empty", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    if (details.length == 0) {
      valid = false;
      toast.error("Details is empty", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (addonsobj.length == 0) {
      valid = false;
      toast.error("Addons is empty", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    //Additem validation end
    console.log(FoodItemInsertView);
    console.log(Editdata.foodItemSchedulerMapperList);
    var url =
      apiAddress +
      "/api/FoodItems/UpdateFoodItem?foodItemId=" +
      Editdata.foodItems.id;
    var valid = true;
    if (valid) {
      SetloadingModal(true);
      try {
        const response = await axios.put(url, FoodItemInsertView);
        console.log(response.data);
        toast.success("Successfully Saved", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } catch (error) {
        console.error("Error saving food item:", error);
        toast.error("Failed to save food item", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } finally {
        SetloadingModal(false);
      }
    }
  };
  console.log(props.editData);
  const [EditRestaurant, setEditRestaurant] = useState([]);

  const loadEditRestaurant = (Reslist) => {
    console.log(Reslist);
    var list = [];
    props.editData.foodItemRestaurantMapperList.map((d, i) => {
      var obj = Reslist.find((x) => x.id == d.restaurantId);
      list.push(obj);
    });
    console.log(list);
    setEditRestaurant(list);
    //setRestaurantAdded(list)
  };

  //const [LinkedData, setLinkedData] = useState([])

  const loadEditMenus = (Reslist) => {
    console.log(Reslist);
    var list = [];
    console.log(props.editData.foodItemSectionMenuRestaurantMapperGetViews);
    props.editData.foodItemSectionMenuRestaurantMapperGetViews.map((d, i) => {
      var obj = Reslist.find((x) => x.id == d.menuId);

      list.push(obj);
    });
    console.log(list);
    setEditMenu(list);
    //setMenuId(list)
  };

  const loadEditSection = (Reslist) => {
    console.log(Reslist);
    var list = [];
    console.log(props.editData.foodItemSectionMenuRestaurantMapperGetViews);
    props.editData.foodItemSectionMenuRestaurantMapperGetViews.map((d, i) => {
      var obj = Reslist.find((x) => x.id == d.sectionId);

      list.push(obj);
    });
    console.log(list);
    //setSelectedValue(list)
    //setEditMenu(list)
    //setMenuId(list)
  };

  const loadLinkedInfos = async () => {
    console.log(Editdata.foodItems.id);
    axios
      .get(
        apiAddress +
        "/api/FoodItems/GetLinkedFoodItemInfoByFoodItemId?foodItemId=" +
        Editdata.foodItems.id
      )
      .then((response) => {
        console.log(response.data);

        const LinkedData = response.data;
        //setLinkedData(response.data);
        console.log(LinkedData);

        const uniqueResIds = new Set();
        const uniqueMenuIds = new Set();
        const uniqueResMIds = new Set();
        const uniqueMenuMIds = new Set();
        const uniqueSectionMIds = new Set();

        let idCounter = 0;

        var linkedFoodItemList = [];
        var linkedFoodItemList2 = [];
        var resList = [];
        var menuList = [];
        var sectionList = [];

        let modifiedList = [];
        let modifiedResList = [];
        let modifiedMenuList = [];
        let modifiedSectionList = [];
        //var sectionObj = '';

        if (LinkedData.length > 0) {
          console.log("With linked Item");

          const liveResObj = {
            id: LinkedData[0].foodItemRestaurantId,
            title: LinkedData[0].foodItemRestaurantName,
            linkedMenuId: LinkedData[0].foodItemMenuId,
          };
          const liveMenuObj = {
            id: LinkedData[0].foodItemMenuId,
            title: LinkedData[0].foodItemMenuName,
            linkedSectionId: LinkedData[0].foodItemSectionId,
          };
          const liveSecObj = {
            id: LinkedData[0].foodItemSectionId,
            title: LinkedData[0].foodItemSectionName,
            linkedRestaurantId: LinkedData[0].foodItemRestaurantId,
            linkedMenuId: LinkedData[0].foodItemMenuId,
            linkedFoodItemId: LinkedData[0].itemId,
            linkedSectionId: LinkedData[0].foodItemSectionId,
            activeFoodItem: Editdata.foodItems.id
          };



          modifiedResList.push(liveResObj);
          modifiedMenuList.push(liveMenuObj);
          modifiedSectionList.push(liveSecObj);


          LinkedData.map((dt, i) => {
            console.log(dt);

            var obj = {
              id: dt.linkItemId,
              title: dt.foodItemResName,
              linkedRestaurantId: dt.linkedFoodItemRestaurentId,
              linkedMenuId: dt.linkedFoodItemMenuId,
              linkedSectionId: dt.linkedFoodItemSectionId,
              linkedFoodItemId: dt.linkItemId
            };
            var resObj = {
              id: dt.linkedFoodItemRestaurentId,
              title: dt.linkedFoodItemRestaurentName,
              linkedMenuId: dt.linkedFoodItemMenuId,
            };
            var menuObj = {
              id: dt.linkedFoodItemMenuId,
              title: dt.linkedFoodItemMenuName,
              linkedSectionId: dt.linkedFoodItemSectionId,
            };
            var sectionObj = {
              id: dt.linkedFoodItemSectionId,
              title: dt.linkedFoodItemSectionName,
              linkedRestaurantId: dt.linkedFoodItemRestaurentId,
              linkedMenuId: dt.linkedFoodItemMenuId,
              linkedFoodItemId: dt.linkItemId,
              linkedSectionId: dt.linkedFoodItemSectionId,
              activeFoodItem: Editdata.foodItems.id
            };

            var obj2 = {
              id: dt.linkItemId,
              title: dt.foodItemResName + " | " + "Linked",
              linkedRestaurantId: dt.linkedFoodItemRestaurentId,
              linkedMenuId: dt.linkedFoodItemMenuId,
              linkedSectionId: dt.linkedFoodItemSectionId,
              linkedFoodItemId: dt.linkItemId,
              isDelivery: dt.linkendFoodItemIsDelivery,
              isCollectionOnly: dt.linkedFoodItemCollectionOnly,
              restaurantIsDelivery: dt.linkedRestaurantIsDelivery,
              restaurantIsCollectionOnly: dt.linkedRestaurantIsCollectionly,
              menuTypeName: dt.linkedMenuTypeName,
              kitchenId: dt.linkedFoodKitchenId
            };
            linkedFoodItemList.push(obj);
            linkedFoodItemList2.push(obj2);

            const ResidExists = modifiedResList.some(
              (item) => item.id === resObj.id
            );
            const MenuidExists = modifiedMenuList.some(
              (item) => item.id === menuObj.id
            );
            const SecrionidExists = modifiedSectionList.some(
              (item) => item.id === sectionObj.id
            );

            if (!ResidExists) {
              modifiedResList.push(resObj);
            }
            if (!MenuidExists) {
              modifiedMenuList.push(menuObj);
            }
            if (!SecrionidExists) {
              modifiedSectionList.push(sectionObj);
              console.log(modifiedSectionList)
            }
          })
        }
        else {
          console.log("No linked Item");
          var resObj = {
            id: Editdata.foodItems.restaurantId,
            title: Editdata.foodItems.foodItemRestaurantName,
            linkedMenuId: Editdata.foodItems.mainSectionId,
          };
          var menuObj = {
            id: Editdata.foodItems.mainSectionId,
            title: Editdata.foodItems.foodItemMenuName,
            linkedSectionId: Editdata.foodItems.sectionId,
          };
          var sectionObj = {
            id: Editdata.foodItems.sectionId,
            title: Editdata.foodItems.foodItemSectionName,
            linkedRestaurantId: Editdata.foodItems.restaurantId,
            linkedMenuId: Editdata.foodItems.mainSectionId,
            linkedFoodItemId: Editdata.foodItems.id,
            linkedSectionId: Editdata.foodItems.sectionId,
            activeFoodItem: Editdata.foodItems.id
          };

          modifiedResList.push(resObj);
          modifiedMenuList.push(menuObj);
          modifiedSectionList.push(sectionObj);
        }

        setLinkedFoodItems(linkedFoodItemList);
        setinitLinkedFoodItems(linkedFoodItemList);
        setLinkedFoodItems2(modifiedList);
        setLinkedFoodItemsAdded(linkedFoodItemList);
        setFoodItemData(linkedFoodItemList2);
        setRestaurantAdded(modifiedResList);
        setinitRestaurantAdded(modifiedResList);

        setMenuId(modifiedMenuList);
        setinitMenuAdded(modifiedMenuList);

        setSelectedValue(modifiedSectionList);
        setinitSectionAdded(modifiedSectionList);

      });
  };

  useEffect(() => {
    let modifiedList = [];
    let modifiedList2 = [];
    modifiedList = [...linkedFoodItems];
    modifiedList2 = [...foodItemData];

    modifiedList2.push({
      id: Editdata.foodItems.id,
      title: Editdata.foodItems.foodItemRestaurantName + " | " + Editdata.foodItems.foodItemMenuName + " | " + Editdata.foodItems.foodItemSectionName + " | " + Editdata.foodItems.itemName + " | " + "Main",
      foodItemRestaurantId: Editdata.foodItems.restaurantId,
      foodItemMenuId: Editdata.foodItems.mainSectionId,
      foodItemSectionId: Editdata.foodItems.sectionId,
      isDelivery: Editdata.foodItems.isDelivery,
      isCollectionOnly: Editdata.foodItems.isCollectionOnly,
      restaurantIsDelivery: Editdata.foodItems.restaurantIsDelivery,
      menuTypeName: Editdata.foodItems.menuTypeName,
      kitchenId: Editdata.foodItems.kitchenId,
      restaurantIsCollectionOnly: Editdata.foodItems.restaurantIsCollectionOnly
    });

    //setlinkedMenudatas2(modifiedList);
    setFoodItemData(modifiedList2);
  }, [linkedFoodItems]);


  useEffect(() => {
    const fetchData = async () => {
      await loadRestaurantName();
      await loadLinkedInfos();
      loadSubSection();
    };
    fetchData();
  }, [Editdata]);

  useEffect(() => {
    if (Editdata.fooditemSubfilterGetList.length > 0) {
      setswitchCheck(true)
      var SubfilterList = []
      console.log(Editdata.fooditemSubfilterGetList)
      console.log(subSectionImage)

      Editdata.fooditemSubfilterGetList?.map((d, i) => {
        var obj = subSectionImage.find((x) => x?.id == d.subfilterId);
        console.log(obj)

        var subobj = {
          id: d?.id,
          foodItemId: d.fooditemId,
          subfilterId: obj?.id,
          creationId: "123",
          linkedItemIds: d.linkedItemIds,
          title: obj?.title
        };
        SubfilterList.push(subobj);
      });
      setSelectedSubSectionValue(SubfilterList);
      setinitselectedSubSectionValue(SubfilterList)
    }
  }, [subSectionImage])

  useEffect(() => {
    loadMenuData();
    loadKeyword();
    loadAddons(restaurantAdded);
    loadKeywordTags();
  }, [restaurantAdded]);

  useEffect(() => {
    loadSectionData();
  }, [menuid]);

  const getDefaultKeyword = (data) => {
    var list = [];
    var objList = [];
    data.map((d, i) => {
      list.push(d.title);
      var obj = { Id: '123', FoodItemId: '123', KeywordId: d.id, CreationId: '123' }
      objList.push(obj)
    });
    setkeywordObjlist(objList)
    return list;
  };

  const addValueSection = (props) => {
    setSelectedValue(props);
    var selectedList = [];

    props.map((obj) => {
      const object = allSectiondata?.find((x) => x.id == obj.id);
      const linkedobject = selectedValue?.find((x) => x.id == obj.id);
      const newObject = {
        id: obj.id,
        title: object?.keywordName,
        linkedRestaurantId: object?.restaurantId,
        linkedMenuId: object?.menuId,
        linkedFoodItemId: linkedobject?.linkedFoodItemId ?? null,
        linkedSectionId: obj.id,
        activeFoodItem: Editdata.foodItems.id
      };
      selectedList.push(newObject);
    });
    setSelectedValue(selectedList);
  };

  function findNotMatched(array1, array2) {

    const notMatched = [];

    for (let i = 0; i < array1.length; i++) {
      const element = array1[i];

      if (array2.find((x) => x.id == element.id) == undefined) {
        notMatched.push(element);
      }
    }
    return notMatched;
  }
  const [newAddedSection, setnewAddedSection] = useState([]);
  const [cancelledSection, setcancelledSection] = useState([]);
  useEffect(() => {
    if (selectedValue.length > initSectionAdded.length) {
      var newAddedsection = findNotMatched(selectedValue, initSectionAdded);
      setnewAddedSection(newAddedsection);
      setFoodItemCopyDialogType("FoodItem Copy");
      setopenFoodItemCopyDilaog(true);

    } else if (selectedValue.length < initSectionAdded.length) {
      var cancelledRes = findNotMatched(initSectionAdded, selectedValue);
      setcancelledSection(cancelledRes);
      setArchiveDialogType("FoodItem Archive");
      setopenArchiveDilaog(true);
      setArchiveStatus("Bulk Archive")
    }
  }, [selectedValue]);

  useEffect(() => {
    if (linkedFoodItemsAdded.length < initlinkedFoodItems.length) {
      var cancelledRes = findNotMatched(initlinkedFoodItems, linkedFoodItemsAdded);
      setcancelledSection(cancelledRes);
      setArchiveDialogType("FoodItem Archive");
      setopenArchiveDilaog(true);
      setArchiveStatus("Single Archive")
    }
  }, [linkedFoodItemsAdded]);

  const [openEditItemSchedulerSelectionDialog, setopenEditItemSchedulerSelectionDialog] = useState(false);
  const handleItemSchedularDialogOpen = () => {
    setopenEditItemSchedulerSelectionDialog(true)
  }
  const handleItemSchedulerDialogClose = () => {
    setopenEditItemSchedulerSelectionDialog(false)
  }

  const [openEditDeliveryDialog, setopenEditDeliveryDialog] = useState(false);
  const handleDeliveryDialogOpen = () => {
    setopenEditDeliveryDialog(true)
  }
  const handleDeliveryDialogClose = () => {
    setopenEditDeliveryDialog(false)
  }

  //archive start

  const [openArchiveDilaog, setopenArchiveDilaog] = useState(false);
  const [openFoodItemCopyDilaog, setopenFoodItemCopyDilaog] = useState(false);
  const [ArchiveDialogType, setArchiveDialogType] = useState("");
  const [ArchiveStatus, setArchiveStatus] = useState("");
  const [FoodItemCopyDialogType, setFoodItemCopyDialogType] = useState("");

  const onUpdate = async () => {
    // setopenArchiveDilaog(true)
    // setArchiveDialogType("FoodItem Archive")

    let FoodItemId = Editdata.foodItems.id;
    let isLinkageUpdate = false;

    if (linkedFoodItemsAdded.length === 0) {
      isLinkageUpdate = false;
    } else {
      isLinkageUpdate = true;
    }

    var ItemNameobj = {};
    var ItemDesobj = {};
    var ItemPriceExclusiveobj = {};
    var ItemVatTypeobj = {};
    var VatIdobj = {};
    var VatAmountobj = {};
    var IsDeliveryobj = {};
    var IsCollectionOnlyobj = {};

    var ItemSDTypeobj = {};
    var SDIdobj = {};
    var SDAmountobj = {};
    var SDFixedAmountobj = {};

    var ItemMinimumIncrementSize = {};
    var ItemMinimumOrderSize = {};

    var VatOnSDIdobj = {};
    var VatOnSDAmountobj = {};
    var VatOnSDTypeobj = {};

    const Data = [];

    if (initMinimumIncrementSize !== minimumIncreamentSize) {
      ItemMinimumIncrementSize = {
        columnName: "MinimumIncrementSize",
        columnValue: minimumIncreamentSize,
      };
      Data.push(ItemMinimumIncrementSize);
    }

    if (initMinimumOrderSize !== minimumOrderSize) {
      ItemMinimumOrderSize = {
        columnName: "MinimumOrderSize",
        columnValue: minimumOrderSize,
      };
      Data.push(ItemMinimumOrderSize);
    }

    if (initselectedItemValue !== selectedItemValue) {
      ItemNameobj = {
        columnName: "ItemName",
        columnValue: selectedItemValue,
      };
      Data.push(ItemNameobj);
    }

    if (initdescirptionVal !== descirptionVal) {
      ItemDesobj = {
        columnName: "Description",
        columnValue: descirptionVal,
      };
      Data.push(ItemDesobj);
    }

    if (initpriceExclusive !== priceExclusive) {
      ItemPriceExclusiveobj = {
        columnName: "ItemBasePrice",
        columnValue: priceExclusive,
      };
      Data.push(ItemPriceExclusiveobj);
    }

    if (initradiovalue !== radiovalue) {
      ItemVatTypeobj = {
        columnName: "VATType",
        columnValue: radiovalue,
      };
      Data.push(ItemVatTypeobj);

      if (radiovalue == 'auto') {
        VatIdobj = {
          columnName: "VatId",
          columnValue: vatAdded.id,
        };
        VatAmountobj = {
          columnName: "SpecifyVATinPercentage",
          columnValue: null,
        };
        Data.push(VatIdobj);
        Data.push(VatAmountobj);
      }
      else if (radiovalue == 'Specify') {
        VatIdobj = {
          columnName: "VatId",
          columnValue: null,
        };
        VatAmountobj = {
          columnName: "SpecifyVATinPercentage",
          columnValue: `${vatInAmount}`,
        };
        Data.push(VatIdobj);
        Data.push(VatAmountobj);
      }
    }

    if (initradiovalue == radiovalue) {
      if (radiovalue == 'auto') {
        if (initvatAdded != vatAdded) {
          VatIdobj = {
            columnName: "VatId",
            columnValue: vatAdded.id,
          };
          Data.push(VatIdobj);
        }
      }

      if (radiovalue == 'Specify') {
        if (initcustomVat != customVat) {
          VatAmountobj = {
            columnName: "SpecifyVATinPercentage",
            columnValue: `${vatInAmount}`,
          };
          Data.push(VatAmountobj);
        }
      }
    }

    if (initradiovalueSD !== radiovalueSD) {
      ItemSDTypeobj = {
        columnName: "SdType",
        columnValue: radiovalueSD,
      };
      Data.push(ItemSDTypeobj);

      if (radiovalueSD == 'auto') {
        SDIdobj = {
          columnName: "SdId",
          columnValue: sdAdded?.id,
        };
        SDAmountobj = {
          columnName: "SDPercentage",
          columnValue: null,
        };
        SDFixedAmountobj = {
          columnName: "SdInAmount",
          columnValue: null,
        };
        Data.push(SDIdobj);
        Data.push(SDAmountobj);
        Data.push(SDFixedAmountobj);
      }
      else if (radiovalueSD == 'Specify') {
        SDIdobj = {
          columnName: "SdId",
          columnValue: null,
        };
        SDAmountobj = {
          columnName: "SDPercentage",
          columnValue: `${vatInAmount}`,
        };
        SDFixedAmountobj = {
          columnName: "SdInAmount",
          columnValue: null,
        };
        Data.push(SDIdobj);
        Data.push(SDAmountobj);
        Data.push(SDFixedAmountobj);
      }
      else if (radiovalueSD == 'Fixed') {
        SDIdobj = {
          columnName: "SdId",
          columnValue: null,
        };
        SDAmountobj = {
          columnName: "SDPercentage",
          columnValue: null,
        };
        SDFixedAmountobj = {
          columnName: "SdInAmount",
          columnValue: `${SdAmount}`,
        };
        Data.push(SDIdobj);
        Data.push(SDAmountobj);
        Data.push(SDFixedAmountobj);
      }
    }

    if (initradiovalueVatonSD !== radiovalueVatonSD) {
      VatOnSDTypeobj = {
        columnName: "VatonSdType",
        columnValue: radiovalueVatonSD,
      };
      Data.push(VatOnSDTypeobj);

      if (radiovalueVatonSD == 'auto') {
        VatOnSDIdobj = {
          columnName: "VatonSdId",
          columnValue: vatOnSdAdded?.id,
        };
        VatOnSDAmountobj = {
          columnName: "VatonSDPercentage",
          columnValue: null,
        };
        Data.push(VatOnSDIdobj);
        Data.push(VatOnSDAmountobj);
      }
      else if (radiovalueVatonSD == 'Specify') {
        VatOnSDIdobj = {
          columnName: "VatonSdId",
          columnValue: null,
        };
        VatOnSDAmountobj = {
          columnName: "VatonSDPercentage",
          columnValue: `${VatOnSdInAmount}`,
        };
        Data.push(VatOnSDIdobj);
        Data.push(VatOnSDAmountobj);
      }
    }

    if (initradiovalueVatonSD == radiovalueVatonSD) {
      if (radiovalueVatonSD == 'auto') {
        if (initvatOnSdAdded != vatOnSdAdded) {
          VatOnSDIdobj = {
            columnName: "VatonSdId",
            columnValue: vatOnSdAdded.id,
          };
          Data.push(VatOnSDIdobj);
        }
      }

      if (radiovalueVatonSD == 'Specify') {
        if (initcustomVatonSD != customVatonSD) {
          VatOnSDAmountobj = {
            columnName: "VatonSDPercentage",
            columnValue: `${VatOnSdInAmount}`,
          };
          Data.push(VatOnSDAmountobj);
        }
      }
    }

    FoodItemInsertView.FoodItemStory = story ? story : storyObj; //story object

    //await fileUpload();
    if (ImageBruteCheck) {
      var Url = []
      for (let i = 0; i < state.selectedImages?.length; i++) {
        if (
          typeof state.selectedImages[i] === "string" &&
          state.selectedImages[i].startsWith("https://")
        ) {
          var obj = {
            Id: "123",
            FoodItemId: "123",
            ItemImagePath: state.selectedImages[i],
            CreationId: "123",
            totalNumbersOfImage: '5',
            cropImageTypeId: '4314f388-816d-4ce0-b618-b7585b7a709e',
            Status: "Add"
          };
          Url.push(obj);

        }
        else if (state.selectedImages[i].startsWith("data:")) {
          for (let i = 0; i < imageFile?.length; i++) {
            var res = await uploadOneFiles(imageFile[i]);
            var obj = {
              Id: "123",
              FoodItemId: "123",
              ItemImagePath: res[0],
              CreationId: "123",
              totalNumbersOfImage: '5',
              cropImageTypeId: '4314f388-816d-4ce0-b618-b7585b7a709e',
              Status: "Add"
            };
            Url.push(obj);
          }
        }
        else {
          var res = await uploadOneFiles(imageFile[i]);
          console.log(res)
          var obj = {
            Id: "123",
            FoodItemId: "123",
            ItemImagePath: res[0],
            CreationId: "123",
            totalNumbersOfImage: '5',
            cropImageTypeId: '4314f388-816d-4ce0-b618-b7585b7a709e',
            Status: "Add"
          };
          Url.push(obj);
        }
      }
      // setImageUrl(Url)
      FoodItemInsertView.FoodItemImageMapperList = Url;
    }
    else {
      await ImagefileUpload();
    }

    var scheduleList = [];

    Schedule.map((dt, i) => {
      console.log(dt);
      dt.schedule.map((d, i) => {
        var obj = {
          Id: "123",
          FoodItemId: "123",
          SchedulerId: d.id,
          Quantity: dt.quantity,
          CreationId: "123",
        };
        scheduleList.push(obj);
      });
    });

    var addonsobj = [];

    FoodItemInsertView.updatedColumnsViews = Data;

    let keywordObj = []
    let keywordTagObj = []
    let SubFiltersObj = []

    if (keywordCheck) {
      var objList = []
      keywordObjlist.map((d, i) => {
        var obj = {
          Id: d?.Id,
          title: d?.title,
          FoodItemId: d?.FoodItemId ?? '123',
          KeywordId: d?.KeywordId,
          CreationId: "123",
          LinkedItemIds: d?.LinkedItemIds ?? [],
          Status: "Add"
        }
        objList.push(obj)
      })
      keywordObj = objList;
    }
    else {
      keywordObj = KeywordModify();
    }

    if (keywordTagCheck) {
      var objList = []
      keywordTagList.map((d, i) => {
        var obj = {
          Id: d?.Id,
          title: d?.title,
          FoodItemId: d?.FoodItemId ?? '123',
          KeywordTagId: d?.KeywordTagId,
          CreationId: "123",
          LinkedItemIds: d?.LinkedItemIds ?? [],
          Status: "Add"
        }
        objList.push(obj)
      })
      keywordTagObj = objList;
    }
    else {
      keywordTagObj = KeywordTagModify();
    }

    if (SubfiltersBruteCheck) {
      var objList = []
      selectedSubSectionValue.map((d, i) => {
        var obj = {
          id: d?.id,
          title: d?.title,
          foodItemId: d?.foodItemId ?? '123',
          subfilterId: d?.subfilterId,
          creationId: "123",
          linkedItemIds: d?.linkedItemIds ?? [],
          Status: "Add"
        }
        objList.push(obj)
      })
      SubFiltersObj = objList;
    }
    else {
      SubFiltersObj = SubfiltersModify();
    }

    if (AddonsBruteCheck) {
      var objList = []
      selectedAddons.map((d, i) => {
        const rank = rowsData.find((x) => x.AddonName == d.title);
        var obj = {
          Id: d?.Id,
          title: d?.title,
          FoodItemId: d?.FoodItemId ?? '123',
          AddOnsId: d?.AddOnsId,
          CreationId: "123",
          LinkedItemIds: d?.LinkedItemIds ?? [],
          Status: "Add",
          Rank: rank?.Rank,
          isCountableLinked: rank?.isCountableLinked,
          isMandatory: rank?.isMandatory
        }
        objList.push(obj)
      })
      addonsobj = objList;
    }
    else {
      addonsobj = AddonsModify();
    }


    var addonsOptionsObj = [];

    const getBaseName = (name) => name?.replace(" | Countable", "");
    rowsData.map((dt, i) => {
      const object = selectedAddons?.find(
        (x) => getBaseName(x.title) === getBaseName(dt.AddonName)
      );
      if (!object) return; // skip if not found
      dt.option.map((op, i) => {
        var optionObj = {
          Id: "123",
          FoodItemId: "123",
          AddOnsId: object.AddOnsId,
          optionsId: op.addOnOptionsMaster.id,
          CreationId: "123",
          isCountableLinked: op.addOnOptionsMaster?.isCountableLinked,
          isMandatory: op.addOnOptionsMaster?.isMandatory,
          isOptionMustPick: dt?.isOptionMustPick
        };
        addonsOptionsObj.push(optionObj)
      })
    });

    const kitchenUpdatePayload = [];
    selectedValue.forEach(section => {
      const kitchen = getkitchens[section.id]; // Get the kitchen data for the section
      if (kitchen) {
        kitchenUpdatePayload.push({
          foodItemId: kitchen.foodItemId, // Assuming Editdata.foodItems.id is the foodItemId
          sectionId: section.id,
          kitchenId: kitchen.id.toString()
        });
      }
    });
    FoodItemInsertView.isKeyowrdBrute = keywordCheck;
    FoodItemInsertView.isKeyowrdTagBrute = keywordTagCheck;
    FoodItemInsertView.isSubfiltersBrute = SubfiltersBruteCheck;
    FoodItemInsertView.isImageBrute = ImageBruteCheck;
    FoodItemInsertView.isAddonsBrute = AddonsBruteCheck;

    FoodItemInsertView.FoodItemKeywordMapperList = keywordObj;
    FoodItemInsertView.FoodItemKeywordTagMapperList = keywordTagObj;
    FoodItemInsertView.FoodItemAddOnsMapperList = addonsobj;
    FoodItemInsertView.foodItemAddOnsOptionsMapperList = addonsOptionsObj;
    FoodItemInsertView.FoodItemSchedulerMapperList =
      scheduleList.length > 0
        ? scheduleList
        : Editdata.foodItemSchedulerMapperList;
    FoodItemInsertView.fooditemSubfilterMapperList = SubFiltersObj ?? [];

    SetloadingModal(true);
    console.log(FoodItemInsertView)
    try {
      const kitchenUpdateResponse = await axios.post(`${apiAddress}/api/FoodItems/UpdateKitchenInFoodItems`, kitchenUpdatePayload);

      var url = apiAddress + '/api/FoodItems/testUpdateLinkedItems?id=' + FoodItemId + '&updateLinkage=' + isLinkageUpdate;
      console.log(FoodItemInsertView)
      const response = await axios.put(url, FoodItemInsertView);

      toast.success("Food Item Succesfully Updated", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })
      props.onHandleAddItem(false);
    } catch (error) {
      console.error("Error updating food item:", error);
      toast.error("Failed to update food item", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      SetloadingModal(false);
    }
  };


  const handleAddArchiveItem = async () => {
    setinitLinkedFoodItems(linkedFoodItemsAdded)
    setopenArchiveDilaog(false);
    setopenFoodItemCopyDilaog(false);
    await loadLinkedInfos();
  };
  const handleDialog = async () => {

    setopenArchiveDilaog(false);
    setopenFoodItemCopyDilaog(false);

    await loadLinkedInfos();

  };
  const [openLinkModal, setopenLinkModal] = useState(false);
  const hanldeLinkmodalclose = async () => {
    setopenLinkModal(false);
    await loadLinkedInfos();
  };

  const [openEditRankModal, setOpenEditRankModal] = useState(false);

  const handleRankModalOpen = () => {
    setOpenEditRankModal(true);
    setDialogType("Edit Rank");
  };

  const handleRankClose = (editRank) => {
    setOpenEditRankModal(editRank);
  };
  const selectedSectionAddedValue = (props) => {
    var list = [];
    var obj2 = {}
    props.map((dt, i) => {
      const object = subSectionImage?.find((x) => x.title == dt.title);
      const linkedobject = initselectedSubSectionValue?.find((x) => x.title == dt.title);
      var obj = {
        id: linkedobject?.id ?? "123",
        title: object?.title,
        foodItemId: linkedobject?.foodItemId ?? '123',
        subfilterId: object?.id,
        creationId: "123",
        linkedItemIds: linkedobject?.linkedItemIds ?? []
      }
      list.push(obj);
    });
    setSelectedSubSectionValue(list);
    setKeywordTagsErr(false);
  };
  const RestauranttokenLocal = JSON.parse(localStorage.getItem("restaurant"));

  useEffect(() => {
    axios
      .get(
        apiAddress +
        "/api/Vat/GetAllVatListByRestaurantIdAsync?restaurantId=" + RestauranttokenLocal?.id
      )
      .then((response) => {
        var list = [];
        response.data?.map((dt, i) => {
          var obj =
          {
            id: dt.id,
            title: dt.name,
            percentage: dt.percentage
          };
          list.push(obj);
        });
        setvatDatas(list);
      });
  }, []);

  useEffect(() => {
    if (Editdata.foodItems.vatId && vatDatas) {
      const object = vatDatas?.find((x) => x.id == Editdata.foodItems.vatId);
      setvatAdded(object);
      setinitvatAdded(object)
      setvatInAmount(object?.percentage)
    }
    else {
      setCustomVat(Editdata.foodItems.specifyVATinPercentage)
      setinitCustomVat(Editdata.foodItems.specifyVATinPercentage)
      setvatInAmount(Editdata.foodItems.specifyVATinPercentage)
    }
  }, [vatDatas]);

  useEffect(() => {
    if (vatAdded && vatAdded.percentage) {
      setIsactive(false);
      setvatInAmount(vatAdded.percentage);

      var vatPrice = vatAdded.percentage / 100
      var total = vatPrice * priceExclusive;
      setVatAmount(total);
      setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    } else if (customVat) {
      setvatInAmount(customVat);
      var vatPrice = customVat / 100
      var total = vatPrice * priceExclusive;
      setVatAmount(total);
      setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    } else {
      setvatInAmount(0);
      setVatAmount(0);
      setpriceInclusive(0)
    }
  }, [vatAdded, customVat]);

  const [radiovalueSD, setRadiovalueSD] = useState(
    Editdata.foodItems.sdType
  );

  const [initradiovalueSD, setinitRadiovalueSD] = useState(
    Editdata.foodItems.sdType
  );
  const [customSD, setCustomSD] = useState("");
  const [sdDatas, setsdDatas] = useState([]);
  const [sdAdded, setsdAdded] = useState(null);
  const [SdAmount, setSdAmount] = useState(0);
  const [SdInAmount, setSdInAmount] = useState(0.0);

  const [initcustomSD, setinitCustomSD] = useState("");
  const [initSdAdded, setinitSdAdded] = useState(null);
  const [initSdAmount, setinitSdAmount] = useState(0);


  const [radiovalueVatonSD, setRadiovalueVatonSD] = useState(
    Editdata.foodItems.vatonSDType
  );

  const [initradiovalueVatonSD, setinitRadiovalueVatonSD] = useState(
    Editdata.foodItems.vatonSDType
  );

  const [customVatonSD, setCustomVatonSD] = useState("");
  //const [sdDatas, setsdDatas] = useState([]);
  const [vatOnSdAdded, setVatOnSdAdded] = useState(null);
  const [VatOnSdAmount, setVatOnSdAmount] = useState(0);
  const [VatOnSdInAmount, setVatOnSdInAmount] = useState(0.0);

  const [initcustomVatonSD, setinitCustomVatonSD] = useState("");
  const [initvatOnSdAdded, setinitVatOnSdAdded] = useState(null);
  const [initVatOnSdAmount, setinitVatOnSdAmount] = useState(0);

  const handleRadioChangeVatOnSD = (event) => {
    const value = event.target.value;
    setRadiovalueVatonSD(value);

    if (value === "Specify") {
      setVatOnSdAdded(null); // Clear selected VAT when switching to custom input
      setCustomVatonSD("");  // Reset custom VAT field
    } else {
      setCustomVatonSD("");  // Reset custom VAT when switching to Autocomplete
    }
  };

  const handleRadioChangeSD = (event) => {
    const value = event.target.value;
    setRadiovalueSD(value);

    if (value === "Specify") {
      setsdAdded(null); // Clear selected VAT when switching to custom input
      setCustomSD("");  // Reset custom VAT field
    } else {
      setCustomSD("");  // Reset custom VAT when switching to Autocomplete
    }
  };

  const inAmountSDValue = (props) => {

    if (radiovalueSD === "Specify") {

    }
    else if (radiovalueSD === "auto") {

    }
    else if (radiovalueSD === "Fixed") {
      setSdAmount(props)
    }
  };

  const inPercentageSDValue = (props) => {
    // var Vatprice = props / 100;
    // var total = Vatprice * priceExclusive;
    // setVatAmount(total);
    // setvatInAmount(props);
    // setpriceInclusive(parseInt(priceExclusive) + parseInt(total));
    // setVatErr(false);
  };

  function getPercentageOrAmount(amount1: number, amount2: number, mode: string): number | string {
    if (mode === 'percentage') {
      return (amount2 / amount1) * 100; // amount2 is what percentage of amount1
    } else if (mode === 'amount') {
      return (amount1 * amount2) / 100; // amount2% of amount1
    } else {
      return 'Invalid mode';
    }
  }

  useEffect(() => {
    if (sdAdded && sdAdded.percentage) {
      setIsactive(false);
      setSdInAmount(sdAdded.percentage);

      var sdPrice = sdAdded.percentage / 100
      var total = sdPrice * priceExclusive;
      setSdAmount(total);
      //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    } else if (customSD) {
      setSdInAmount(customSD);
      var vatPrice = customSD / 100
      var total = vatPrice * priceExclusive;
      setSdAmount(total);
      //setpriceInclusive(parseFloat(priceExclusive) + parseFloat(total));

    } else {
      setSdInAmount(0);
      setSdAmount(0);
      //setpriceInclusive(0)
    }
  }, [sdAdded, customSD]);

  useEffect(() => {
    if (vatOnSdAdded && vatOnSdAdded.percentage) {
      setIsactive(false);
      setVatOnSdInAmount(vatOnSdAdded.percentage);

      var sdPrice = vatOnSdAdded.percentage / 100
      var total = sdPrice * SdAmount;
      setVatOnSdAmount(total.toFixed(2));

    } else if (customVatonSD) {
      setVatOnSdInAmount(customVatonSD);
      var vatPrice = customVatonSD / 100
      var total = vatPrice * SdAmount;
      setVatOnSdAmount(total);

    } else {
      setVatOnSdInAmount(0);
      setVatOnSdAmount(0);
    }
  }, [vatOnSdAdded, customVatonSD, SdAmount]);

  useEffect(() => {
    const vatAM = parseFloat(priceExclusive) * (parseFloat(vatInAmount) / 100)

    const sdAM = parseFloat(priceExclusive) * (parseFloat(SdInAmount) / 100)

    const vatonsdAM = parseFloat(sdAM) * (parseFloat(VatOnSdInAmount) / 100)

    setVatAmount(vatAM)
    setSdAmount(sdAM)
    setVatOnSdAmount(vatonsdAM.toFixed(2))

    const value = parseFloat(priceExclusive) + parseFloat(vatAmount) + parseFloat(SdAmount) + parseFloat(VatOnSdAmount)
    setpriceInclusive(value.toFixed(2))
  }, [priceExclusive])

  useEffect(() => {
    const value = parseFloat(priceExclusive) + parseFloat(vatAmount) + parseFloat(SdAmount)
    setpriceInclusive(value.toFixed(2))
  }, [vatAmount])

  useEffect(() => {
    const value = parseFloat(priceExclusive) + parseFloat(vatAmount) + parseFloat(SdAmount)
    setpriceInclusive(value.toFixed(2))
  }, [SdAmount])

  useEffect(() => {
    const value = parseFloat(priceExclusive) + parseFloat(vatAmount) + parseFloat(SdAmount) + parseFloat(VatOnSdAmount)
    setpriceInclusive(value.toFixed(2))
  }, [VatOnSdAmount])

  //sd data populate
  useEffect(() => {
    if (Editdata.foodItems.sdId && vatDatas) {
      const object = vatDatas?.find((x) => x.id == Editdata.foodItems.sdId);
      setsdAdded(object);
      setinitSdAdded(object);
      setSdInAmount(object?.percentage)
    }
    else if (radiovalueSD === 'Spacify' && Editdata.foodItems.sdPercentage) {
      setCustomSD(Editdata.foodItems.sdPercentage)
      setinitCustomSD(Editdata.foodItems.sdPercentage)
      setSdInAmount(Editdata.foodItems.sdPercentage)
    }
    else if (radiovalueSD === 'Fixed' && Editdata.foodItems.sdInAmount) {
      // setCustomSD(Editdata.foodItems.sdPercentage)
      // setinitCustomSD(Editdata.foodItems.sdPercentage)
      // setSdInAmount(Editdata.foodItems.sdPercentage)
      setSdAmount(Editdata.foodItems.sdInAmount)
      setinitSdAmount(Editdata.foodItems.sdInAmount)
    }
  }, [vatDatas]);

  // vat on sd data load
  useEffect(() => {
    if (Editdata.foodItems.vatonSDId && vatDatas) {
      const object = vatDatas?.find((x) => x.id == Editdata.foodItems.vatonSDId);
      setVatOnSdAdded(object);
      setinitVatOnSdAdded(object)
      setVatOnSdInAmount(object?.percentage)
    }
    else {
      setCustomVatonSD(Editdata.foodItems.vatonSdPercentage)
      setinitCustomVatonSD(Editdata.foodItems.vatonSdPercentage)
      setVatOnSdInAmount(Editdata.foodItems.vatonSdPercentage)
    }
  }, [vatDatas]);

  const [IsCollectionCheck, setIsCollectionCheck] = useState(Editdata.foodItems.isCollectionOnly);
  const [initIsCollectionCheck, setinitIsCollectionCheck] = useState(Editdata.foodItems.isCollectionOnly);

  const handleCollectionCheck = () => {
    if (IsCollectionCheck == true) {
      setIsCollectionCheck(false);
    } else {
      setIsCollectionCheck(true);
    }
  };

  const [kitchens, setKitchens] = useState<string[]>([]);
  const [getkitchens, setgetkitchens] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (restaurantAdded.length > 0 && selectedValue.length > 0) {
          let restaurantArray = restaurantAdded.map(dt => dt?.id);
          let sectionArray = selectedValue.map(d => d?.id);

          // Fetch kitchen data based on restaurant and section
          const kitchenResponse = await axios.post(
            `${apiAddress}/api/FoodItems/GetResturentSectionKitchenAsync`,
            {
              restaurantIds: restaurantArray,
              sectionIds: sectionArray,
            }
          );

          let kitchenData = kitchenResponse.data; // Main kitchen data

          // Fetch kitchen data based on food item
          const foodItemObjects = [];
          Editdata.foodItemKeywordTagMapperList.forEach(mapper => {
            foodItemObjects.push({ foodItemId: mapper.foodItemId });

            if (mapper.linkedItemIds && mapper.linkedItemIds.length > 0) {
              mapper.linkedItemIds.forEach(linkedItem => {
                foodItemObjects.push({ foodItemId: linkedItem.linkItemId });
              });
            }
          });

          const uniqueFoodItemIds = Array.from(
            new Set(foodItemObjects.map(item => item.foodItemId))
          ).map(foodItemId => ({ foodItemId }));

          const foodItemResponse = await axios.post(
            `${apiAddress}/api/FoodItems/GetKitchenbyfoodId`,
            uniqueFoodItemIds,
            {
              headers: { "Content-Type": "application/json" },
            }
          );

          let foodItemKitchenData = foodItemResponse.data; // Kitchen by foodItem

          // **Merge sections with kitchen mapping**
          const updatedSections = kitchenData.map(rest => ({
            ...rest,
            sections: rest.sections.map(section => {
              const matchedKitchen = foodItemKitchenData.find(
                item => item.sectionId === section.id
              );
              return {
                ...section,
                kitchen: matchedKitchen ? matchedKitchen.kitchenName : section.kitchen,
              };
            }),
          }));

          setKitchens(updatedSections);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [Editdata, restaurantAdded, selectedValue]);

  const getkitchensFnc = (props) => {
    setgetkitchens(props);
    // Schedule.push(props)
  };

  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuDialogclose = (data) => {
    setOpenMenu(data)
  };

  const loadMenuOnFly = () => {
    loadMenuData();
  };
  const loadSectionOnFly = () => {
    loadSectionData();
  };

  const HandleNothing = () => {
  };

  const tabs = [
    { label: "Add item", value: "1" },
    { label: "Details", value: "2" },
    { label: "Story", value: "3" },
    { label: "Instruction", value: "4" },
    // { label: "Kitchen", value: "5" },
  ];

  //const [value, setValue] = useState("1");

  const currentIndex = tabs.findIndex((tab) => tab.value === value);

  const goToNextTab = () => {
    if (currentIndex < tabs.length - 1) {
      setValue(tabs[currentIndex + 1].value);
    }
  };

  const goToPreviousTab = () => {
    if (currentIndex > 0) {
      setValue(tabs[currentIndex - 1].value);
    }
  };
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const handleAddDialogClose = () => {
    props.onHandleAddItem(false);
    //setKeyword(null)
    setopenConfirmaitonModal(false);
  };

  //archive ends
  return (
    <>
      <div>
        <ToastContainer />
        <LoadingView open={loadingModal} close={closeLoadingModal} />
        <SweetAlertModal
          headerText={"Do you want to leave without saving?"}
          bodyText={"All changes made will be lost"}
          open={openConfirmaitonModal}
          onyes={handleAddDialogClose}
          close={() => {
            setopenConfirmaitonModal(false);
          }}
          id={2}
        />
        <React.Fragment>
          <Dialog
            fullWidth={true}
            maxWidth={"xl"}
            open={props.open}
            onClose={handleClose}
          >
            <Grid container>
              <Grid item xs={6}>
                <DialogTitle>
                  <div className="d-flex" style={{ gap: "8px" }}>
                    <div>
                      <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                    </div>

                    <span style={{ color: "#2a7fd4" }}>
                      GoTaste :- Edit item{" "}
                    </span>
                  </div>
                </DialogTitle>
              </Grid>
              <Grid item xs={6}>
                <DialogActions>
                  <Button onClick={handleClose}>
                    <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                  </Button>
                </DialogActions>
              </Grid>
            </Grid>
            <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
              <Stepper activeStep={activeStep}>
                {steps.map((label, index) => {
                  const stepProps: { completed?: boolean } = {};
                  const labelProps: {
                    optional?: React.ReactNode;
                  } = {};

                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}>{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
              {/* {

              (activeStep === 0 ? ( */}
              <div className={`${activeStep == 0 ? "d-block " : "d-none"} `}>
                <React.Fragment>
                  {/* <div
                    className="d-flex justify-content-end"
                    style={{ gap: "10px" }}
                  >
                    <img
                      src={importImg}
                      alt=""
                      style={{ width: "1.5rem" }}
                      onClick={() => {
                        setOpenImport(!openImport);
                      }}
                    />
                    <span>Import</span>
                  </div> */}

                  <ImportItemView
                    open={openImport}
                    dialogType={dialogType}
                    onHandleAddItem={handleImportItem}
                  />

                  {/* <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Add item" value="1" />
                        <Tab label="Details" value="2" />
                        <Tab label="Story" value="3" />
                        <Tab label="Instruction" value="4" />
                        <Tab label="Kitchen" value="5" />
                      </TabList>
                    </Box>
                  </TabContext> */}

                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList onChange={handleChange} aria-label="lab API tabs example">
                        {tabs.map((tab) => (
                          <Tab key={tab.value} label={tab.label} value={tab.value} />
                        ))}
                      </TabList>
                    </Box>
                  </TabContext>

                  {/* {value === '1' && ( */}
                  <div className={`${value == "1" ? "d-block " : "d-none"} `}>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Linked FoodItems
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        {linkedFoodItems !== null && (
                          <AutoCompleteMultiSelect
                            label={props.title}
                            placeholder={"Linked FoodItems"}
                            value={linkedFoodItemAddedvalue}
                            datas={linkedFoodItems}
                            // defaultValue={menuIds}
                            val={linkedFoodItemsAdded}
                            id={88}
                          />
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        className="AddItemplusIcon"
                        onClick={() => setopenLinkModal(true)}
                      >
                        <button className="modalAddButton">+Link Items</button>
                        {/* <img src={plusIcon} alt="+" /> */}
                      </Grid>
                    </Grid>

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <div
                          className="d-flex"
                          style={{ paddingTop: "1rem", gap: "10px" }}
                        >
                          <Typography>Restaurant</Typography>
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        {/* {EditRestaurant.length > 0 && restaurantDatas.length > 0 ? ( */}
                        <AutoCompleteMultiSelect
                          id={2}
                          placeholder={"Restaurant"}
                          datas={restaurantDatas}
                          value={restaurantAddedvalue}
                          val={restaurantAdded}
                        />

                        {/* ) : <img src={preloader} alt='preloader' style={{ width: '2rem' }} />
                        } */}
                        {RestaurantErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Menu
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        {EditMenu ? (
                          <AutoCompleteMultiSelect
                            label={props.title}
                            placeholder={"Filter/Section"}
                            value={addValue}
                            datas={Menudata}
                            //defaultValue={EditMenu}
                            val={menuid}
                            id={88}
                          />
                        ) : (
                          <img src={preloader} style={{ width: "2rem" }} />
                        )}
                        {MainsectionErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        className="AddItemplusIcon"
                        onClick={() => setOpenMenu(true)}
                      >
                        <button className="modalAddButton">
                          +Add Menu
                        </button>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <div
                          className="d-flex"
                          style={{ paddingTop: "1rem", gap: "10px" }}
                        >
                          <Typography>Section/Filter</Typography>
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Select a section category for this food item
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoOutlinedIcon style={{ color: "#371B17" }} />
                          </HtmlTooltip>
                        </div>
                      </Grid>
                      <Grid item xs={9}>
                        {EditSection ? (
                          <AutoCompleteMultiSelect
                            label={props.title}
                            placeholder={"Section/Filter"}
                            // value={(props)=>{}}
                            value={addValueSection}
                            datas={Sectiondata}
                            val={selectedValue}
                            //  defaultValue = {selectedValue}

                            id={88}
                          />
                        ) : (
                          <img
                            src={preloader}
                            alt="preloader"
                            style={{ width: "2rem" }}
                          />
                        )}
                        {MainsectionErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                      <Grid item xs={1} className="AddItemplusIcon">
                        <button
                          className="modalAddButton"
                          onClick={handleClickOpen}
                        >
                          +Add Section
                        </button>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "0.5rem" }}>
                          Sub section/Sub filter
                        </Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Switch
                          checked={switchCheck}
                          onChange={handleSwitchChange}
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      </Grid>
                    </Grid>
                    {switchCheck && (
                      <Grid container sx={{ padding: "0.5rem" }}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={9} style={{ paddingTop: "1rem" }}>
                          <AutoCompleteMultiSelect
                            id={88}
                            placeholder={"Select a Sub Filter"}
                            datas={subSectionImage}
                            value={selectedSectionAddedValue}
                            val={selectedSubSectionValue}
                          />
                        </Grid>
                        {subFiltersMsgErr && (
                          <Grid item xs={0.5} style={{ paddingTop: "1.5rem", paddingLeft: "1rem" }}>
                            <HtmlTooltip
                              title={
                                <React.Fragment>
                                  <Typography color="inherit">
                                    Subfilters that are listed below will get removed from Linked Item :
                                    <Table>
                                      <TableHead>
                                        <TableRow>
                                          <TableCell align='center'>Subfilter Name</TableCell>
                                          <TableCell align='center'>Linked Item Name</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {CancelledSubFilters.map((row, index) => (
                                          <TableRow key={index}>
                                            <TableCell align="center">{row.title}</TableCell>
                                            <TableCell align="center">
                                              {row.linkedItemIds.map((d) => d.linkedItemName).join(" , ")}
                                            </TableCell>
                                          </TableRow>
                                        ))}
                                      </TableBody>
                                    </Table>
                                  </Typography>
                                </React.Fragment>
                              }
                            >
                              <InfoOutlinedIcon style={{ color: "#FF0000" }} />
                            </HtmlTooltip>
                          </Grid>
                        )}
                        <Grid item xs={0.5} style={{ paddingTop: "1rem", paddingLeft: "1rem" }}>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={SubfiltersBruteCheck}
                                  onChange={handleSubfiltersCheck}
                                />
                              }
                              label=""
                            />
                          </FormGroup>
                        </Grid >
                      </Grid>
                    )}
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Item Name
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          label={"Item name"}
                          value={nameValue}
                          val={selectedItemValue}
                        />
                        {ItemNameErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Description
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={1}
                          label={"Description"}
                          value={descirptionValue}
                          val={descirptionVal}
                        />
                        {DescriptionErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Image
                        </Typography>
                      </Grid>
                      <Grid xs={1.5}>
                        <Button
                          variant="contained"
                          component="label"
                          //   color="primary"
                          style={{ backgroundColor: "white", color: "gray" }}
                        >
                          <img
                            src={galleryIcon}
                            alt="gallery-Icon"
                            style={{ width: "2rem" }}
                          />
                          Upload
                          <input
                            hidden
                            accept="image/*"
                            multiple
                            type="file"
                            onChange={handleImageUpload}
                            disabled={state.selectedImages.length >= 5}
                          />
                        </Button>
                      </Grid>
                      <Grid item xs={1} style={{ paddingTop: "0.3rem", paddingLeft: "1rem" }}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={ImageBruteCheck}
                                onChange={handleImageBruteCheck}
                              />
                            }
                            label=""
                          />
                        </FormGroup>
                      </Grid >

                      {/* image show start */}
                      <Grid container sx={{ padding: "0.5rem" }}>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={9}>
                          <Grid container spacing={2}>
                            {state.selectedImages.map((image, index) => (
                              <Grid item xs={2} sm={2} md={2} key={index}>
                                {/* <Paper> */}
                                <div
                                  style={{
                                    position: "relative",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <img
                                    src={image}
                                    alt={`Preview ${index + 1}`}
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <IconButton
                                    style={{
                                      position: "absolute",
                                      top: "-6px",
                                      right: "-23px",
                                      color: "gray",
                                    }}
                                    onClick={() => handleDeleteImage(index)}
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </div>
                                {/* </Paper> */}
                              </Grid>
                            ))}
                          </Grid>
                          <div style={{ paddingTop: "1rem" }}>
                            {ImageErr && (
                              <span style={{ color: "red" }}>
                                This field is required
                              </span>
                            )}
                          </div>
                        </Grid>
                      </Grid>
                      {/* image show end */}
                    </Grid>
                    {/* <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <div
                          className="d-flex"
                          style={{ paddingTop: "1rem", gap: "10px" }}
                        >
                          <Typography>Keywords</Typography>
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Add up to 4 keyword filters to identify the
                                  item. Sub-filters that were previously added
                                  can be re-used across your menus
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoOutlinedIcon style={{ color: "#371B17" }} />
                          </HtmlTooltip>
                        </div>
                      </Grid>
                      {Editkeyword.length >= 0 ? (
                        <Grid item xs={9}>
                          <Autocomplete
                            multiple
                            id="free-solo-with-text-demo"
                            options={keywordDatas.map((option) => option.title)}
                            freeSolo
                            onChange={handleKeywordChange}
                            value={Editkeyword?.map(d => d?.title)}
                            renderTags={(
                              value: readonly string[],
                              getTagProps
                            ) =>
                              value.map((option: string, index: number) => (
                                <Chip
                                  variant="outlined"
                                  label={option}
                                  {...getTagProps({ index })}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder={"Keywords"}
                                onKeyDown={handleKeyDown}
                              />
                            )}
                          />
                          {KeywordErr && (
                            <span style={{ color: "red" }}>
                              This field is required
                            </span>
                          )}
                        </Grid>
                      ) : (
                        <img src={preloader} style={{ width: "2rem" }} />
                      )}
                      {keywordMsgErr && (
                        <Grid item xs={0.5} style={{ paddingTop: "1rem", paddingLeft: "1rem" }}>
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Keyword that are listed below will get removed from Linked Item :
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align='center'>Keword Name</TableCell>
                                        <TableCell align='center'>Linked Item Name</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {CancelledKeyword.map((row, index) => (
                                        <TableRow key={index}>
                                          <TableCell align="center">{row.title}</TableCell>
                                          <TableCell align="center">
                                            {row.LinkedItemIds.map((d) => d.linkedItemName).join(" , ")}
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoOutlinedIcon style={{ color: "#FF0000" }} />
                          </HtmlTooltip>
                        </Grid>
                      )}
                      <Grid item xs={0.5} style={{ paddingTop: "0.5rem", paddingLeft: "1rem" }}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={keywordCheck}
                                onChange={handleKeywordCheck}
                              />
                            }
                            label=""
                          />
                        </FormGroup>
                      </Grid >
                    </Grid> */}

                    {/* <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Keywords tags
                        </Typography>
                      </Grid>
                      {DefaultKeywordTag.length > 0 ? (
                        <Grid item xs={9}>
                          <AutoCompleteMultiSelect
                            label={"Keywords tags"}
                            placeholder={"Keywords tags"}
                            value={addkeywordtag}
                            datas={keywordTagdata}
                            defaultValue={DefaultKeywordTag}
                            id={2}
                          />
                          {KeywordTagsErr && (
                            <span style={{ color: "red" }}>
                              This field is required
                            </span>
                          )}
                        </Grid>
                      ) : (
                        <img src={preloader} style={{ width: "2rem" }} />
                      )}
                      {keywordTagMsgErr && (
                        <Grid item xs={0.5} style={{ paddingTop: "1rem", paddingLeft: "1rem" }}>
                          <HtmlTooltip
                            title={
                              <React.Fragment>
                                <Typography color="inherit">
                                  Keyword Tags that are listed below will get removed from Linked Item :
                                  <Table>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell align='center'>Keword Tag Name</TableCell>
                                        <TableCell align='center'>Linked Item Name</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {CancelledKeywordTag.map((row, index) => (
                                        <TableRow key={index}>
                                          <TableCell align="center">{row.title}</TableCell>
                                          <TableCell align="center">
                                            {row.LinkedItemIds.map((d) => d.linkedItemName).join(" , ")}
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Typography>
                              </React.Fragment>
                            }
                          >
                            <InfoOutlinedIcon style={{ color: "#FF0000" }} />
                          </HtmlTooltip>
                        </Grid>
                      )}
                      <Grid item xs={0.5} style={{ paddingTop: "0.5rem", paddingLeft: "1rem" }}>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={keywordTagCheck}
                                onChange={handleKeywordTagCheck}
                              />
                            }
                            label=""
                          />
                        </FormGroup>
                      </Grid >
                    </Grid> */}


                    {/* <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Minimum Order Size
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Minimum Order Size"}
                          value={AddMinimumOrderValue}
                          val={minimumOrderSize}
                        />
                        {PriceErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid> */}

                    {/* <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Maximum Order Size
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Maximum Order Size"}
                          value={AddMaximumOrderValue}
                          val={maximumOrderSize}
                        />
                        {PriceErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid> */}

                    {/* <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Minimum Increment Size
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Minimum Increment Size"}
                          value={AddMinimumIncreamentValue}
                          val={minimumIncreamentSize}
                        />
                        {PriceErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid> */}

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Price (Exclusive)
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Price (Exclusive)"}
                          value={setpriceExclusiveval}
                          val={priceExclusive}
                        />
                        {PriceErr && (
                          <span style={{ color: "red" }}>
                            This field is required
                          </span>
                        )}
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          VAT (Amount)
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <Grid xs={5}>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={radiovalue}
                            onChange={handleRadioChange}
                          >
                            <FormControlLabel
                              value="auto"
                              control={<Radio />}
                              label="Select from VAT List"
                            />
                            <span style={{ paddingTop: "0.5rem", paddingRight: "0.5rem" }} > - Or - </span>

                            <FormControlLabel
                              value="Specify"
                              control={<Radio />}
                              label="Specify VAT"
                            />
                          </RadioGroup>


                          {radiovalue === "auto" && (
                            <Autocomplete
                              id="free-solo-with-text-demo"
                              options={vatDatas}
                              value={vatAdded}
                              onChange={(event, newInputValue) => {
                                setvatAdded(newInputValue);
                              }}
                              className="my-3"
                              getOptionLabel={(option) => option?.title || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  variant="outlined"
                                  label="Select VAT"
                                  disabled={radiovalue !== "auto"}
                                />
                              )}
                            />
                          )}


                          {radiovalue === "Specify" && (
                            <TextField
                              label="Specify VAT Percentage"
                              variant="outlined"
                              value={customVat}
                              onChange={(e) => setCustomVat(e.target.value)}
                              className="my-3"
                              type="number"
                              placeholder="Enter VAT percentage"
                            />
                          )}
                        </Grid>
                        <div>
                          <Grid container>
                            <Grid xs={3.5}>
                              <TextAreaComponents
                                id={2}
                                label={"VAT (%)"}
                                value={inPercentageVATValue}
                                //val={vatInAmount !== 0 ? vatInAmount : ""}
                                val={vatInAmount ?? ""}
                                isactive={isactive}
                                placeholder={"VAT (%)"}
                              />
                              {VatErr && (
                                <span style={{ color: "red" }}>
                                  This field is required
                                </span>
                              )}
                            </Grid>
                            <Grid xs={3} className="ms-2">
                              <TextAreaComponents
                                id={2}
                                label={"VAT (Amount)"}
                                value={inAmountVATValue}
                                val={vatAmount.toFixed(2)}
                                isactive={isactive}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          SD
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <Grid xs={6}>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={radiovalueSD}
                            onChange={handleRadioChangeSD}
                          >
                            <FormControlLabel
                              value="auto"
                              control={<Radio />}
                              label="Select from SD List"
                            />
                            <span style={{ paddingTop: "0.5rem", paddingRight: "0.5rem" }} > - Or - </span>

                            <FormControlLabel
                              value="Specify"
                              control={<Radio />}
                              label="Specify SD"
                            />

                            <span style={{ paddingTop: "0.5rem", paddingRight: "0.5rem" }} > - Or - </span>

                            <FormControlLabel
                              value="Fixed"
                              control={<Radio />}
                              label="Fixed SD"
                            />

                          </RadioGroup>

                          {radiovalueSD === "auto" && (
                            <Grid container alignItems="center">
                              <Grid item xs={7}>
                                <Autocomplete
                                  id="free-solo-with-text-demo"
                                  options={vatDatas}
                                  value={sdAdded}
                                  onChange={(event, newInputValue) => {
                                    setsdAdded(newInputValue);
                                  }}
                                  className="my-3"
                                  getOptionLabel={(option) => option?.title || ""}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      label="Select SD"
                                      disabled={radiovalue !== "auto"}
                                    />
                                  )}
                                />
                              </Grid>
                            </Grid>
                          )}

                          {radiovalueSD === "Specify" && (
                            <TextField
                              label="Specify SD Percentage"
                              variant="outlined"
                              value={customSD}
                              onChange={(e) => setCustomSD(e.target.value)}
                              className="my-3"
                              type="number"
                              placeholder="Enter SD percentage"
                            />
                          )}

                          {radiovalueSD === "Fixed" && (
                            <Grid paddingBottom={2}></Grid>
                          )}
                        </Grid>
                        <div>
                          <Grid container>
                            <Grid xs={3.5}>
                              <TextAreaComponents
                                id={2}
                                label={"SD (%)"}
                                value={inPercentageVATValue}
                                val={SdInAmount !== 0 ? SdInAmount : ""}
                                isactive={isactive}
                                placeholder={"SD (%)"}
                              />
                              {VatErr && (
                                <span style={{ color: "red" }}>
                                  This field is required
                                </span>
                              )}
                            </Grid>
                            <Grid xs={3} className="ms-2">
                              <TextAreaComponents
                                id={2}
                                label={"SD (Amount)"}
                                value={inAmountSDValue}
                                val={SdAmount}
                                isactive={isactive}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          VAT On SD
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <Grid xs={6}>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={radiovalueVatonSD}
                            onChange={handleRadioChangeVatOnSD}
                          >
                            <FormControlLabel
                              value="auto"
                              control={<Radio />}
                              label="Select from VAT List"
                            />
                            <span style={{ paddingTop: "0.5rem", paddingRight: "0.5rem" }} > - Or - </span>

                            <FormControlLabel
                              value="Specify"
                              control={<Radio />}
                              label="Specify VAT On SD"
                            />
                          </RadioGroup>


                          {radiovalueVatonSD === "auto" && (
                            <Grid container alignItems="center">
                              <Grid item xs={7}>
                                <Autocomplete
                                  id="free-solo-with-text-demo"
                                  options={vatDatas}
                                  value={vatOnSdAdded}
                                  onChange={(event, newInputValue) => {
                                    setVatOnSdAdded(newInputValue);
                                  }}
                                  className="my-3"
                                  getOptionLabel={(option) => option?.title || ""}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      variant="outlined"
                                      label="Select VAT"
                                      disabled={radiovalue !== "auto"}
                                    />
                                  )}
                                />
                              </Grid>
                            </Grid>
                          )}


                          {radiovalueVatonSD === "Specify" && (
                            <TextField
                              label="Specify VAT Percentage"
                              variant="outlined"
                              value={customVatonSD}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value === "" || Number(value) >= 0) { // Ensure the value is valid or empty
                                  setCustomVatonSD(value);
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "-" || e.key === "e") {
                                  e.preventDefault(); // Prevent typing "-" or "e" in the input
                                }
                              }}
                              className="my-3"
                              type="number"
                              placeholder="Enter VAT percentage"
                            />
                          )}
                        </Grid>
                        <div>
                          <Grid container>
                            <Grid xs={3.5}>
                              <TextAreaComponents
                                id={2}
                                label={"VAT (%)"}
                                value={inPercentageVATValue}
                                val={VatOnSdInAmount !== 0 ? VatOnSdInAmount : ""}
                                isactive={isactive}
                                placeholder={"VAT (%)"}
                              />
                              {VatErr && (
                                <span style={{ color: "red" }}>
                                  This field is required
                                </span>
                              )}
                            </Grid>
                            <Grid xs={3} className="ms-2">
                              <TextAreaComponents
                                id={2}
                                label={"VAT (Amount)"}
                                value={inAmountVATValue}
                                val={VatOnSdAmount}
                                isactive={isactive}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Price (Inclusive)
                        </Typography>
                      </Grid>
                      <Grid xs={9}>
                        <TextAreaComponents
                          id={2}
                          label={"Price (Inclusive)"}
                          value={textFieldValue}
                          val={priceInclusive}
                        />
                      </Grid>
                    </Grid>

                    {/* <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid xs={2}>
                        <Typography style={{ paddingTop: "0.5rem" }}>
                          Rank
                        </Typography>
                      </Grid>
                      <Grid xs={2}>
                        <button style={{ textAlign: "left" }}
                          className="modalAddButton"
                          onClick={handleRankModalOpen}
                        >
                          Edit Rank
                        </button>
                      </Grid>
                    </Grid> */}

                    {/* <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Is Deliverable
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <button style={{ textAlign: "left" }}
                          className="modalAddButton"
                          onClick={handleDeliveryDialogOpen}
                        >
                          Edit Delivery
                        </button>
                      </Grid>
                      <EditDeliveryDialog
                        open={openEditDeliveryDialog}
                        onClose={handleDeliveryDialogClose}
                        // foodItems={foodItemData} // Pass your API data here
                        foodItems={foodItemData} // Pass your API data here

                      />
                    </Grid> */}

                    {/* <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography>Scheduler</Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <button style={{ textAlign: "left" }}
                          className="modalAddButton"
                          onClick={handleItemSchedularDialogOpen}
                        >
                          Edit Scheduler
                        </button>
                      </Grid>
                      <EditItemSchedulerSelectionDialog
                        open={openEditItemSchedulerSelectionDialog}
                        onClose={handleItemSchedulerDialogClose}
                        // foodItems={foodItemData} // Pass your API data here
                        foodItems={foodItemData} // Pass your API data here
                      />
                    </Grid> */}

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>Addons</Typography>
                      </Grid>
                      <Grid item xs={10}>
                        <Grid
                          container
                          sx={{ alignItems: "center" }}
                          spacing={3}
                        >
                          {DefaultAddons.length <= 0 ? (
                            <Grid item xs={7}>
                              <AutoCompleteMultiSelect
                                key={DefaultAddons.length}
                                id={2}
                                placeholder={"Add ons"}
                                datas={addOnDatas}
                                value={addonvalue}
                              // Set when items exist
                              />
                              {AddonsErr && (
                                <span style={{ color: "red" }}>This field is required</span>
                              )}
                            </Grid>
                          ) : (
                            <Grid item xs={7}>
                              <AutoCompleteMultiSelect
                                key={DefaultAddons.length}
                                id={2}
                                placeholder={"Add ons"}
                                datas={addOnDatas}
                                value={addonvalue} // No defaultValue
                                defaultValue={DefaultAddons}
                              />
                              {AddonsErr && (
                                <span style={{ color: "red" }}>This field is required</span>
                              )}
                            </Grid>
                          )}
                          {AddonsMsgErr && (
                            <Grid item xs={0.5} style={{ paddingTop: "1rem", paddingLeft: "1rem" }}>
                              <HtmlTooltip
                                title={
                                  <React.Fragment>
                                    <Typography color="inherit">
                                      Addons that are listed below will get removed from Linked Item :
                                      <Table>
                                        <TableHead>
                                          <TableRow>
                                            <TableCell align='center'>Addons Name</TableCell>
                                            <TableCell align='center'>Linked Item Name</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {CancelledAddons.map((row, index) => (
                                            <TableRow key={index}>
                                              <TableCell align="center">{row.title}</TableCell>
                                              <TableCell align="center">
                                                {row.LinkedItemIds.map((d) => d.linkedItemName).join(" , ")}
                                              </TableCell>
                                            </TableRow>
                                          ))}
                                        </TableBody>
                                      </Table>
                                    </Typography>
                                  </React.Fragment>
                                }
                              >
                                <InfoOutlinedIcon style={{ color: "#FF0000" }} />
                              </HtmlTooltip>
                            </Grid>
                          )}
                          <Grid item xs={1} style={{ paddingTop: "1rem", paddingLeft: "1rem" }}>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={AddonsBruteCheck}
                                    onChange={handleAddonsCheck}
                                  />
                                }
                                label=""
                              />
                            </FormGroup>
                          </Grid >
                        </Grid>

                        <ImportSpecification
                          open={openImportSpecification}
                          onClose={handleCloseImportSpecification}
                          onSave={handleAddSpecification}
                          onHandleAddItem={handleimportedDatas}
                        />
                        <AddSpecification
                          open={open}
                          onClose={handleCloseSpecifications}
                          onSave={handleAddSpecification}
                          dialogName={"Add Addons"}
                        />
                      </Grid>
                    </Grid>
                    {openEditRankModal && (
                      <EditRankDialog
                        open={openEditRankModal}
                        dialogType={dialogType}
                        onHandleAddItem={handleRankClose}
                        foodItemId={Editdata.foodItems.id}
                      />)}

                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={9}>
                        {rowsData.length > 0 ? (
                          <TableContainer component={Paper}>
                            <Table aria-label="collapsible table">
                              <TableHead>
                                <TableRow>
                                  <TableCell />
                                  <TableCell>Must Pick
                                    <span>  </span>
                                    <Switch
                                      checked={isMustPick}
                                      onChange={handleMustPick}
                                      size="small" // optional: makes the switch smaller
                                    />
                                  </TableCell>
                                  <TableCell align="center">Rank</TableCell>
                                  <TableCell align="center">AddOn Name</TableCell>
                                  <TableCell align="right">IsToggle</TableCell>
                                  <TableCell align="right">
                                    {" "}
                                    buttonStyle
                                  </TableCell>
                                  <TableCell align="right">
                                    maxSelection
                                  </TableCell>
                                  <TableCell align="center">Link with fooditem</TableCell>
                                  <TableCell>Mandatory</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {rowsData.map((row, idx) => (
                                  <Row key={row?.name} row={row} idx={idx} onToggle={linktoggle} onMandetoryToggle={mandatorytoggle} />
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </div>
                  <div className={`${value == "2" ? "d-block " : "d-none"} `}>
                    <Details
                      sendToAddItem={getDetailsdata}
                      defaultData={Editdata.foodItemDetailList}
                      openFrom={"EditItem"}
                      FooditemId={props.editData.foodItems.id}
                    />
                  </div>
                  <div className={`${value == "3" ? "d-block " : "d-none"} `}>
                    <Story
                      sendStoryToAdditem={getStorydata}
                      ForEdit={Editdata.foodItemStory}
                    />
                  </div>
                  <div className={`${value == "4" ? "d-block " : "d-none"} `}>
                    <Instructions
                      sendInstructionToAdditem={getInstructiondata}
                      defaultData={Editdata.foodItemInstructionList}
                      openFrom={"EditItem"}
                      FooditemId={props.editData.foodItems.id}
                    />
                  </div>

                  <div className={`${value == "5" ? "d-block " : "d-none"} `}>
                    <EditItemKitchen foodItems={foodItemData} kitchens={kitchens} getKitchens={getkitchensFnc} />
                  </div>
                  {/* )} */}
                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button
                      //variant="outlined"
                      onClick={goToPreviousTab}
                      disabled={currentIndex === 0}
                    >
                      {currentIndex > 0 && `< ${tabs[currentIndex - 1].label}`}
                    </Button>

                    <Button
                      //variant="contained"
                      onClick={goToNextTab}
                      disabled={currentIndex === tabs.length - 1}
                    >
                      {currentIndex < tabs.length - 1 &&
                        `${tabs[currentIndex + 1].label} >`}
                    </Button>
                    <Button onClick={onUpdate}>

                      {activeStep === steps.length - 1 ? "Finish" : "Update"}
                    </Button>
                  </Box>
                </React.Fragment>
              </div>
              {/* ) : (activeStep === 1 ? ( */}
              <div className={`${activeStep == 1 ? "d-block " : "d-none"} `}>
                <React.Fragment>
                  <SchedulerComponent
                    getSchedule={getSchedule}
                    selectedItem={Editdata.schedulers}
                    // isEdit={"true"}
                    from={"discount"}
                    defaultData={Editdata.foodItemSchedulerMapperList}
                    showSchedulerTable={true}
                  ></SchedulerComponent>

                  <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                    <Box sx={{ flex: "1 1 auto" }} />
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                    >
                      Back
                    </Button>
                    {activeStep === steps.length - 1 ? (

                      <Button onClick={onUpdate}>Update</Button>
                    ) : (
                      <Button
                        color='error'
                      >
                        Archive
                      </Button>
                      // onClickArchive <Button onClick={handleNext}>Next</Button>
                    )}
                  </Box>
                </React.Fragment>
              </div>
            </DialogContent>
          </Dialog>
        </React.Fragment>
      </div>
      {openAddSection && (
        <AddSectionDialog
          open={openAddSection}
          dialogType={dialogType}
          onHandleAddItem={handleAddItem}
          loaddataonfly={loadSectionOnFly}
          onHandleSelectedData={HandleNothing}
        />
      )}
      <KeywordDialog
        open={openAddKeyword}
        onHandleKeywordDialog={handleKeywordDialog}
      />
      <FoodItemArchiveDialog
        open={openArchiveDilaog}
        dialogType={ArchiveDialogType}
        onHandleAddItem={handleAddArchiveItem}
        onClose={handleDialog}
        ActiveItem={Editdata.foodItems}
        cancledRes={cancelledSection}
        linkedFoodItems={linkedFoodItems2}
        linkdata={linkedFoodItems}
        Status={ArchiveStatus}
      // cancleMenus={cancelledMenus}
      />
      <FoodItemCopyDialog
        open={openFoodItemCopyDilaog}
        dialogType={FoodItemCopyDialogType}
        onHandleAddItem={handleAddArchiveItem}
        onClose={handleDialog}
        // id={selectedRowId}
        cancledRes={linkedFoodItems2}
        addNewSec={newAddedSection}
        ActiveItem={Editdata.foodItems}
      />
      {openLinkModal && (
        <FoodItemLinkDialog
          open={openLinkModal}
          linkmodalclose2={hanldeLinkmodalclose}
          Openfrom={"Edit"}
        />
      )}

      {openMenu && (
        <AddMenuDialog
          open={openMenu}
          dialogType={"Add Menu"}
          onHandleAddItem={handleMenuDialogclose}
          loaddataonfly={loadMenuOnFly}
          onHandleSelectedData={HandleNothing}
        />
      )}
    </>
  );
}

export default EditItemDialog;
